(function () {
  "use strict";

  var html = document.documentElement;
  var header = document.querySelector(".site-header");
  var toggle = document.querySelector(".nav-toggle");
  var nav = document.querySelector(".nav");
  var langBtns = document.querySelectorAll(".lang button");
  var currentLang = (html.lang || "").toLowerCase().indexOf("zh") === 0 ? "zh" : (html.lang === "en" ? "en" : "de");
  var applyFormLang = function () {};

  var STR = {
    en: {
      nav_home: "Home",
      nav_snow: "Snow",
      nav_water: "Water",
      nav_construct: "Construction",
      nav_about: "About",
      nav_start: "Start a board",
      nav_faq: "FAQ",
      nav_refund: "Refund",
      hero_place: "Switzerland.",
      hero_line: "Your ride. Your design.",
      door_snow: "Snow",
      door_water: "Water",
      door_snow_p: "Custom snowboards.",
      door_water_p: "Hard boards for water.",
      door_go: "Open",
      brands_line: "Shops, teams, new names — a short branded line.",
      cta_start: "Start a board",
      footer_place: "Switzerland",
      skip: "Skip to content",
      aria_home: "carvd. home",
      aria_nav: "Primary",
      aria_lang: "Language",
      aria_menu: "Open menu",
      construct_line: "Construction is the product.",
      cta_begin: "Begin",
      title_home: "carvd. — Custom snowboards and water craft",
      title_snow: "Snow — carvd.",
      title_water: "Custom Water Board. Your Design. | carvd.",
      title_construct: "Construction — carvd.",
      title_about: "About — carvd.",
      title_faq: "FAQ — carvd.",
      title_refund: "Refund — carvd.",
      title_start: "Start a board — carvd.",
      snow_kicker: "Snow",
      snow_h1: "Custom Snowboard. Your Design.",
      snow_lede: "Design your own snowboard. Four shapes, your graphic, specs with you. One board or a short line. Start a board.",
      snow_who: "carvd. is based in Switzerland. Custom snowboards to your design. Four shapes, your graphic, specs with you. One board or a short line. No stock boards.",
      snow_how: "Start a board. You pick a shape, send details and artwork. We write back within 48 hours with a quote and a timeline. Write: <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>",
      snow_q1: "What is a custom snowboard from carvd.?",
      snow_a1: "Every snowboard is built to spec. We do not sell stock boards.",
      snow_q2: "Can I design my own snowboard in Switzerland?",
      snow_a2: "Yes. carvd. is based in Switzerland. Start a board is the start.",
      snow_q3: "What shapes?",
      snow_a3: "Classic, Park Camber, Powder, Bluntish. Length and width with you.",
      snow_q4: "How long, and what does it cost?",
      snow_a4: "Around six weeks after confirmation and deposit. October to December, closer to eight. We do not publish prices. After the brief, you get a quote.",
      snow_why_kicker: "Why custom",
      snow_why_h2: "A catalogue board is an average. Yours is not.",
      snow_why_1_h: "The shape you ride",
      snow_why_1_p: "Four profiles. You pick the one that matches the mountain — not a middle that tries to please everyone.",
      snow_why_2_h: "Your graphic",
      snow_why_2_p: "Upload artwork, or work with us. The topsheet carries your mark. Not ours.",
      snow_why_3_h: "Specs you set",
      snow_why_3_p: "Flex, length, how it should hold an edge. We guide. You decide.",
      snow_why_4_h: "One, or a line",
      snow_why_4_p: "A single board for a rider. A short run for a shop, a team, a new name.",
      snow_shapes_kicker: "Shapes",
      snow_shapes_h2: "Four profiles. Different terrain.",
      snow_shapes_lede: "Pick the one that matches how you ride. Length, waist, and camber are set with you.",
      snow_shape_classic: "Directional control for varied terrain",
      snow_shape_park: "Symmetrical, tricks and features",
      snow_shape_powder: "Wide and floaty for deep snow",
      snow_shape_bluntish: "Versatile hybrid for any conditions",
      snow_kreuzli_kicker: "Limited run",
      snow_kreuzli_p: "One locked graphic. You pick the shape and the length.",
      snow_kreuzli_cta: "On Ricardo",
      water_kreuzli_kicker: "Limited run",
      water_kreuzli_p: "One locked graphic. You pick the shape and the length.",
      water_kreuzli_cta: "On Ricardo",
      snow_journey_kicker: "The journey",
      snow_journey_h2: "Five steps. Then the snow.",
      snow_j1_h: "Choose your shape",
      snow_j1_p: "Classic, Park Camber, Powder, or Bluntish. If you are not sure, we help you choose.",
      snow_j2_h: "Design your graphics",
      snow_j2_p: "Upload artwork, or work with us. Topsheet and base, settled before anything is built.",
      snow_j3_h: "Set your specs",
      snow_j3_p: "Flex, size, performance. We walk it with you.",
      snow_j4_h: "We build it",
      snow_j4_p: "Your board is built. You stay updated.",
      snow_j5_h: "Receive and ride",
      snow_j5_p: "The board arrives. Bindings, wax, and the mountain you had in mind.",
      snow_build_kicker: "How we build",
      snow_build_h2: "The spec is the product.",
      snow_build_lede: "Sintered base. Engineered core. Ceramic edges. The full list is on <a class=\"inline\" href=\"/pages/construct\">Construction</a>.",
      snow_cta_h2: "Start a snowboard.",
      snow_cta_p: "One board, or a short line. A brief is enough. We write back.",
      mat_core: "Core",
      mat_core_p: "Paulownia, bamboo, poplar, cork, carbon, honeycomb, titanium. Flex from laminate placement, not only thickness.",
      mat_fibers: "Fibers",
      mat_fibers_p: "High-stitch triax glass. Pre-cured carbon where the ride needs it.",
      mat_edges: "Edges",
      mat_edges_p: "48 Rockwell (40 for rails). Ceramic disk, a mirror finish.",
      mat_bases: "Bases",
      mat_bases_p: "Sintered P-tex 4000 and Electra. A hard extruded base only if asked.",
      mat_epoxy: "Epoxy",
      mat_epoxy_p: "Elastomer, zero VOC.",
      mat_press: "Press",
      mat_press_p: "Full cure, then cold press so the shape holds.",
      mat_damping: "Damping",
      mat_damping_p: "Three layers of rubber / VDS.",
      mat_sidewalls: "Sidewalls",
      mat_sidewalls_p: "PU, sintered P-tex, or bamboo. Not commodity ABS.",
      mat_finish: "Finish",
      mat_finish_p: "Many light grinds. Die-cuts you cannot feel.",
      mat_graphics: "Graphics",
      mat_graphics_p: "Sublimation, screen, die-cut, printed veneer, water transfer, digital. Gloss or matte.",
      water_kicker: "Water",
      water_h1: "Custom Water Board. Your Design.",
      water_lede: "Hard boards for water. Your design. Surf, SUP, foil, and more. One board or a short line. Start a board.",
      water_who: "carvd. is based in Switzerland. Hard water boards to your design: surf, SUP, foil, wake, kite, wind, skim. Boards only. One board or a short line.",
      water_how: "Start a board. Name the type, send details and artwork. We write back within 48 hours. Write: <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>",
      water_q1: "What water boards does carvd. build?",
      water_a1: "Hard boards only. Surf, SUP, foil, wake, kite, wind, skim. No inflatables. No kit.",
      water_q2: "Can I design my own surfboard in Switzerland?",
      water_a2: "Yes. carvd. is based in Switzerland. Start a board is the start.",
      water_q3: "How long, and what does it cost?",
      water_a3: "Around six weeks after confirmation and deposit. We do not publish prices. After the brief, you get a quote.",
      water_line_kicker: "The line",
      water_line_h2: "Hard boards. Every ride.",
      water_surf_h: "Surfboards",
      water_surf_p: "Shortboard, Fish, Longboard, Gun. Mal. Soft top for learning. EPS or PU core. Outline, glass, and fins — set for the wave you ride.",
      water_sup_p: "EPS foam core. Built to spec. Length and volume with you. Your graphic on the deck.",
      water_foil_p: "Surf foil, wing, kite foil. Mast and board set with you.",
      water_wake_p: "Boat or cable. Twin or directional.",
      water_wakesurf_p: "For the wave behind the boat.",
      water_kite_p: "Twintip or directional.",
      water_wind_p: "Freeride to wave. Volume with you.",
      water_skim_p: "Shore break. Thin and stiff.",
      water_shapes_kicker: "Shapes",
      water_shapes_h2: "Named outlines. Pick a type above.",
      water_shapes_lede: "Length and volume are set with you.",
      water_shapes_h2_surf: "Surfboard outlines.",
      water_shapes_h2_sup: "Hard SUP outlines.",
      water_shapes_h2_foil: "Foil outlines.",
      water_shapes_h2_wake: "Wakeboard outlines.",
      water_shapes_h2_wakesurf: "Wakesurf outlines.",
      water_shapes_h2_kite: "Kiteboard outlines.",
      water_shapes_h2_wind: "Windsurf outlines.",
      water_shapes_h2_skim: "Skimboard outlines.",
      water_short_p: "High-performance, responsive, built for powerful surf",
      water_fish_p: "Wider, faster, ideal for smaller and mushier waves",
      water_long_p: "Smooth, classic trim and noseriding on any wave",
      water_gun_p: "Narrow and fast — for big, serious swells",
      water_mal_p: "Classic mid-length. More paddle, more glide",
      water_soft_p: "Soft deck. Built for learning",
      water_sup_allround_p: "Everyday paddle. Length and volume with you",
      water_sup_touring_p: "Longer, tracks true",
      water_sup_race_p: "Narrow, built for speed",
      water_sup_surf_p: "Shorter, for waves",
      water_sup_downwind_p: "For the downwinder",
      water_foil_surf_p: "Behind a wave",
      water_foil_wing_p: "For wing foil",
      water_foil_kite_p: "For kite",
      water_foil_prone_p: "Paddle into foil",
      water_foil_downwind_p: "Downwind foil",
      water_wake_twintip_p: "Boat or cable",
      water_wake_dir_p: "More drive",
      water_wakesurf_surf_p: "More rail, more drive",
      water_wakesurf_skim_p: "Thinner, more slide",
      water_wakesurf_hybrid_p: "In between",
      water_kite_twintip_p: "Freeride / freestyle",
      water_kite_dir_p: "Strap or strapless wave",
      water_wind_freeride_p: "All-round",
      water_wind_wave_p: "Wave sailing",
      water_wind_freestyle_p: "For tricks",
      water_wind_slalom_p: "For speed",
      water_skim_wave_p: "Shore break",
      water_skim_flat_p: "Inland / flat",
      water_start_this: "Start this board",
      water_cta_h2: "Start on water.",
      water_cta_p: "Name the board. A brief is enough.",
      con_kicker: "Construction",
      con_h1: "The ride is in the spec.",
      con_lede: "A custom board is not a graphic on a blank. Construction is the product.",
      con_spec_kicker: "The spec",
      con_spec_h2: "What the board is made of.",
      con_spec_lede: "Sintered base. Engineered core. Ceramic edges. No-VOC epoxy. Locked in a full cure and a cold press.",
      con_cta_h2: "One board, or a short line.",
      con_cta_p: "Not a workshop souvenir. Not a stock board. We write back in 48 hours.",
      about_kicker: "About",
      about_h1: "Custom boards for riders. Short lines for names that need more than one.",
      about_place: "Switzerland.",
      about_p1: "Carvd is based in Switzerland. We make custom snowboards and water craft — shape, graphic, and how it should feel, set with you.",
      about_p2: "On water that is hard boards — surf, SUP, foil, wake, kite, wind, skim. Boards only. Not a kit.",
      about_p3: "We do not sell a graphic on a blank. The spec is sintered bases, engineered cores, ceramic edges — the full list is on <a class=\"inline\" href=\"/pages/construct\">Construction</a>.",
      about_p4: "A brief can be one board. A rider who wants the thing underfoot to be theirs.",
      about_p5: "We also build short branded lines. Shops, teams, new names. A run you can stand behind — not a warehouse of leftover stock.",
      about_p6: "We do not publish prices. Timeline and deposit are on the <a class=\"inline\" href=\"/pages/faq\">FAQ</a>. Write to <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>, and we answer.",
      faq_kicker: "FAQ",
      faq_h1: "Questions.",
      faq_lede: "The facts of a custom order. If something is still open, write to <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>.",
      faq_board: "The board",
      faq_q_custom: "What makes a board custom?",
      faq_a_custom: "Every board is built to spec. We do not sell stock boards. If you order from us, the board that arrives was made for that order.",
      faq_q_shapes: "What shapes?",
      faq_a_shapes: "Snow: Classic, Park Camber, Powder, Bluntish. Any size and width. Water is below.",
      faq_q_flex: "Flex",
      faq_a_flex: "Flex is choosable. If you are not sure, describe the ride. We recommend one when we write back.",
      faq_q_mat: "Materials",
      faq_a_mat: "Sintered P-tex 4000 and Electra bases. Engineered cores. Edges at 48 Rockwell (40 for rails). Elastomer epoxy, zero VOC. Full cure, then a cold press. The full spec is on <a class=\"inline\" href=\"/pages/construct\">Construction</a>.",
      faq_water: "Water",
      faq_q_build: "What we build",
      faq_a_build: "Hard water boards — surf, SUP, foil, wake, kite, wind, skim. Each type has named shapes. Hard SUP with an EPS foam core. Boards only — no inflatables, no kit.",
      faq_design: "Design",
      faq_q_files: "Files",
      faq_a_files: "PNG, JPG, SVG, PDF, AI. Vector is preferred. Raster at 300 DPI.",
      faq_q_nodesign: "No design?",
      faq_a_nodesign: "Describe it. We help. We confirm in the reply.",
      faq_q_colour: "Colour",
      faq_a_colour: "We colour-match. RGB and CMYK can differ. If an exact match matters, we send a proof.",
      faq_order: "Order",
      faq_q_how: "How",
      faq_a_how: "A brief, or the <a class=\"inline\" href=\"/pages/start\">design flow</a>. We reply within 48 hours with a quote and a timeline.",
      faq_q_time: "Build time",
      faq_a_time: "Around six weeks from confirmation and deposit. October–December may be eight weeks.",
      faq_q_deposit: "Deposit",
      faq_a_deposit: "50% to start. Balance before the board ships.",
      faq_q_changes: "Changes",
      faq_a_changes: "Changes are fine before production. Shape and size lock once materials are cut.",
      faq_ship: "Shipping",
      faq_q_where: "Where",
      faq_a_where: "We ship worldwide. Duties and taxes are the buyer’s.",
      faq_q_returns: "Returns",
      faq_a_returns: "No returns on custom once production has started, unless the board is defective or built wrong. Fourteen days for defects. Seven days for shipping damage. The <a class=\"inline\" href=\"/pages/refund\">refund policy</a> has the rest.",
      ref_kicker: "Refund",
      ref_h1: "Refund.",
      ref_updated: "Last updated January 2026.",
      ref_custom_h: "Custom orders",
      ref_custom_p1: "Every board is built to order. Once production has started, we do not accept returns or refunds on custom work.",
      ref_custom_p2: "To cancel, write to <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a> as soon as you can. Cancel before production and the deposit is returned in full. Once materials are cut and pressing has started, the deposit is not refundable.",
      ref_defects_h: "Defects",
      ref_defects_p1: "If the board arrives with a manufacturing defect — delamination, structural failure, or specs we built wrong — we repair or replace it at no cost. Write within 14 days of delivery, with photographs and the original order.",
      ref_defects_p2: "Wear, impact, storage, or changes made after delivery are not covered.",
      ref_wrong_h: "Built wrong",
      ref_wrong_p: "If we built the wrong shape, size, or graphic against the confirmed order, we rebuild or repair it at no cost. Read the confirmation before production starts. Flag a discrepancy at once.",
      ref_deposit_h: "Deposit",
      ref_deposit_p: "50% to begin. Fully refundable if you cancel before production. Not refundable once materials are cut and pressing has started. Applied in full to the remaining balance at shipment.",
      ref_proc_h: "Processing",
      ref_proc_p: "Approved refunds return to the original payment method in 5–10 business days. If it has not arrived after 10 business days, check with the bank first. If it is still missing, write to <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>.",
      ref_ship_h: "Shipping damage",
      ref_ship_p: "If the board is damaged in transit, write within 7 days of delivery with photographs of the damage and the packaging. We work with the carrier toward a replacement or compensation.",
      ref_ret_h: "Return shipping",
      ref_ret_p: "When a return is approved for a defect or a wrong build, we send a prepaid label. For any other approved return, return shipping is the buyer’s. Use a trackable service. We cannot answer for a parcel lost on the way back.",
      ref_contact_h: "Contact",
      ref_contact_p: "Questions, or a claim: <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>. We aim to reply within 48 hours.",
      start_kicker: "Start",
      start_h1: "Start a board.",
      start_lede: "Custom snowboard or surfboard. Your design, shape, and specs. One board or a short line. We write back. <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>",
      start_who: "carvd. is based in Switzerland. We build custom snowboards and water boards to your design: shape, graphic, specs with you. One board or a short line. No stock boards.",
      start_how: "Here is how it works. You pick sport and shape, send details and artwork. We write back within 48 hours with a quote and a timeline. Write: <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>",
      start_q1: "What is a custom board from carvd.?",
      start_a1: "Every board is built to spec. We do not sell stock boards.",
      start_q2: "Can I design my own snowboard in Switzerland?",
      start_a2: "Yes. carvd. is based in Switzerland. Start a board is the start.",
      start_q3: "One board or a line?",
      start_a3: "Both. One board for you, or a short line for a shop, a team, a new name.",
      start_q4: "How long does it take?",
      start_a4: "Around six weeks after confirmation and deposit. October to December, closer to eight.",
      start_q5: "What does it cost?",
      start_a5: "We do not publish prices. After the brief, you get a quote.",
      flow_1: "Shape",
      flow_2: "Details",
      flow_3: "Send",
      aria_steps: "Steps",
      start_line_note: "A short branded line. Pick a sport, then what you want, to begin.",
      start_leg1: "Step 1 — Shape",
      start_sport: "Sport",
      start_what: "What",
      start_shape: "Shape",
      start_surfboard: "Surfboard",
      start_em_classic: "Directional, all-mountain",
      start_em_park: "Twin-tip, freestyle",
      start_em_powder: "Wide directional, backcountry",
      start_em_bluntish: "Hybrid, versatile",
      start_em_short: "High-performance",
      start_em_fish: "Wider, smaller waves",
      start_em_long: "Trim and noseride",
      start_em_gun: "Narrow, big swells",
      start_em_mal: "Mid-length, more glide",
      start_em_soft: "Soft deck, for learning",
      start_em_allround: "Everyday paddle",
      start_em_touring: "Longer, tracking",
      start_em_race: "Narrow, speed",
      start_em_supsurf: "Shorter, for waves",
      start_em_downwind: "Downwinder",
      start_em_surffoil: "Behind a wave",
      start_em_wing: "Wing foil",
      start_em_kitefoil: "Kite",
      start_em_prone: "Paddle into foil",
      start_em_downwindfoil: "Downwind foil",
      start_em_twintip: "Boat or cable",
      start_em_directional: "More drive",
      start_em_surfstyle: "More rail, more drive",
      start_em_skimstyle: "Thinner, more slide",
      start_em_hybrid: "In between",
      start_em_kitetwin: "Freeride / freestyle",
      start_em_kitedir: "Strap or strapless wave",
      start_em_freeride: "All-round",
      start_em_windwave: "Wave sailing",
      start_em_freestyle: "Tricks",
      start_em_slalom: "Speed",
      start_em_skimwave: "Shore break",
      start_em_flatland: "Inland / flat",
      start_continue: "Continue",
      start_leg2: "Step 2 — Details",
      start_name: "Name",
      start_email: "Email",
      ph_name: "Your name",
      ph_email: "you@studio.ch",
      start_length: "Length",
      start_width: "Width",
      start_notsure: "Not sure",
      start_regular: "Regular",
      start_midwide: "Mid-wide",
      start_wide: "Wide",
      start_fins: "Fin setup",
      start_req: "Special requirements",
      ph_req: "Flex, stance, a feel you want underfoot — or leave it, and describe the ride.",
      start_notes: "Anything else",
      ph_notes: "Timing, a reference, a colour. If you have no design, describe it here.",
      start_art: "Artwork",
      start_drop: "<strong>Drop a file</strong> or click to choose. PNG, JPG, SVG, PDF, AI.",
      start_art_note: "The file stays on your machine. Attach it in the draft that opens, or send it in a reply. Vector preferred; raster at 300 DPI.",
      start_back: "Back",
      start_leg3: "Step 3 — Send",
      start_send_kicker: "Send",
      start_draft_h2: "Open a draft.",
      start_draft_note: "Your mail client will open with this note, addressed to custom@carvdboards.com. Attach the file there if you have one.",
      start_copy: "Copy draft",
      start_open: "Open email draft",
      start_success_kicker: "Draft",
      start_success_h2: "The note is ready.",
      start_success_p: "Your mail client should open with the note addressed to custom@carvdboards.com. If it does not, copy the draft and write us. Attach the file in that mail. We will match it to <span data-success-email>your address</span>.",
      start_home: "Back to carvd.",
      start_aside_h: "What helps.",
      start_aside_1: "Snow, or water — and what you want on it.",
      start_aside_2: "Length, and width or fins. “Not sure” is fine.",
      start_aside_3: "How it should feel, if flex is open.",
      start_aside_4: "A file, or a description. We confirm in the reply.",
      start_aside_note: "We reply within 48 hours with a quote and a timeline. <a href=\"/pages/faq\">FAQ</a> · <a href=\"/pages/refund\">Refund</a>",
      notfound_h1: "Not found.",
      notfound_lede: "That page is not here.",
      notfound_back: "Back to carvd."
    },

    de: {
      nav_home: "Start",
      nav_snow: "Snow",
      nav_water: "Wasser",
      nav_construct: "Konstruktion",
      nav_about: "Über uns",
      nav_start: "Board gestalten",
      nav_faq: "FAQ",
      nav_refund: "Rückerstattung",
      hero_place: "Schweiz.",
      hero_line: "Dein Ride. Dein Design.",
      door_snow: "Snow",
      door_water: "Wasser",
      door_snow_p: "Custom-Snowboards.",
      door_water_p: "Hartboards fürs Wasser.",
      door_go: "Öffnen",
      brands_line: "Shops, Teams, neue Namen — eine kurze Linie unter eurer Marke.",
      cta_start: "Board gestalten",
      footer_place: "Schweiz",
      skip: "Zum Inhalt",
      aria_home: "carvd. Start",
      aria_nav: "Hauptnavigation",
      aria_lang: "Sprache",
      aria_menu: "Menü öffnen",
      construct_line: "Konstruktion ist das Produkt.",
      cta_begin: "Beginnen",
      title_home: "carvd. — Custom-Snowboards und Watercraft",
      title_snow: "Snow — carvd.",
      title_water: "Custom Waterboard. Eigenes Design. | carvd.",
      title_construct: "Konstruktion — carvd.",
      title_about: "Über uns — carvd.",
      title_faq: "FAQ — carvd.",
      title_refund: "Rückerstattung — carvd.",
      title_start: "Board beginnen — carvd.",
      snow_kicker: "Snow",
      snow_h1: "Custom Snowboard. Eigenes Design.",
      snow_lede: "Snowboard nach Wunsch. Vier Formen, eigene Grafik, Specs mit dir. Ein Board oder kurze Serie. Board gestalten.",
      snow_who: "carvd. sitzt in der Schweiz. Custom Snowboards nach Wunsch. Vier Formen, eigene Grafik, Specs mit dir. Ein Board oder eine kurze Serie. Kein Lagerboard.",
      snow_how: "Board gestalten. Du wählst ein Shape, schickst Details und Artwork. Wir antworten innert 48 Stunden mit Angebot und Timeline. Schreiben: <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>",
      snow_q1: "Was ist ein Custom Snowboard von carvd.?",
      snow_a1: "Jedes Snowboard wird auf Spec gebaut. Wir verkaufen keine Lagerboards.",
      snow_q2: "Kann ich in der Schweiz ein Snowboard nach Wunsch gestalten?",
      snow_a2: "Ja. carvd. sitzt in der Schweiz. Board gestalten ist der Start.",
      snow_q3: "Welche Shapes?",
      snow_a3: "Classic, Park Camber, Powder, Bluntish. Länge und Breite mit dir.",
      snow_q4: "Wie lange, und was kostet es?",
      snow_a4: "Etwa sechs Wochen nach Bestätigung und Anzahlung. Oktober bis Dezember eher acht. Wir veröffentlichen keine Preise. Nach dem Brief kommt ein Angebot.",
      snow_why_kicker: "Warum custom",
      snow_why_h2: "Ein Katalogboard ist ein Mittelwert. Deins nicht.",
      snow_why_1_h: "Der Shape, den du fährst",
      snow_why_1_p: "Vier Profile. Du nimmst den, der zum Berg passt — nicht die Mitte, die alle bedienen will.",
      snow_why_2_h: "Deine Graphic",
      snow_why_2_p: "Artwork hochladen, oder mit uns. Das Topsheet trägt dein Zeichen. Nicht unseres.",
      snow_why_3_h: "Specs, die du setzt",
      snow_why_3_p: "Flex, Länge, Kantenhalt. Wir führen. Du entscheidest.",
      snow_why_4_h: "Eins, oder eine Linie",
      snow_why_4_p: "Ein einzelnes Board für eine Person. Ein kurzer Lauf für Shop, Team, neuen Namen.",
      snow_shapes_kicker: "Shapes",
      snow_shapes_h2: "Vier Profile. Anderes Terrain.",
      snow_shapes_lede: "Nimm den, der zu deinem Ride passt. Länge, Waist und Camber setzen wir mit dir.",
      snow_shape_classic: "Direktional, Kontrolle auf wechselndem Terrain",
      snow_shape_park: "Symmetrisch, Tricks und Features",
      snow_shape_powder: "Breit und floaty für tiefen Schnee",
      snow_shape_bluntish: "Vielseitiger Hybrid für alle Bedingungen",
      snow_kreuzli_kicker: "Kleine Serie",
      snow_kreuzli_p: "Eine feste Graphic. Du wählst Shape und Länge.",
      snow_kreuzli_cta: "Auf Ricardo",
      water_kreuzli_kicker: "Kleine Serie",
      water_kreuzli_p: "Eine feste Graphic. Du wählst Shape und Länge.",
      water_kreuzli_cta: "Auf Ricardo",
      snow_journey_kicker: "Der Weg",
      snow_journey_h2: "Fünf Schritte. Dann der Schnee.",
      snow_j1_h: "Shape wählen",
      snow_j1_p: "Classic, Park Camber, Powder oder Bluntish. Wenn du unsicher bist, helfen wir.",
      snow_j2_h: "Graphics gestalten",
      snow_j2_p: "Artwork hochladen, oder mit uns. Topsheet und Base, fest bevor gebaut wird.",
      snow_j3_h: "Specs setzen",
      snow_j3_p: "Flex, Grösse, Performance. Wir gehen es mit dir durch.",
      snow_j4_h: "Wir bauen",
      snow_j4_p: "Dein Board wird gebaut. Du bleibst informiert.",
      snow_j5_h: "Ankommen und fahren",
      snow_j5_p: "Das Board kommt. Bindings, Wax, und der Berg, den du im Kopf hattest.",
      snow_build_kicker: "Wie wir bauen",
      snow_build_h2: "Die Spec ist das Produkt.",
      snow_build_lede: "Sintered Base. Engineered Core. Keramikkanten. Die volle Liste steht unter <a class=\"inline\" href=\"/pages/construct\">Konstruktion</a>.",
      snow_cta_h2: "Ein Snowboard beginnen.",
      snow_cta_p: "Ein Board, oder eine kurze Linie. Eine Anfrage reicht. Wir schreiben zurück.",
      mat_core: "Core",
      mat_core_p: "Paulownia, Bambus, Pappel, Kork, Carbon, Honeycomb, Titan. Flex über Laminatlage, nicht nur Dicke.",
      mat_fibers: "Fasern",
      mat_fibers_p: "High-stitch Triax-Glas. Vorgehärtetes Carbon, wo der Ride es braucht.",
      mat_edges: "Kanten",
      mat_edges_p: "48 Rockwell (40 für Rails). Keramikscheibe, Spiegel-Finish.",
      mat_bases: "Bases",
      mat_bases_p: "Sintered P-tex 4000 und Electra. Eine harte extrudierte Base nur auf Wunsch.",
      mat_epoxy: "Epoxy",
      mat_epoxy_p: "Elastomer, null VOC.",
      mat_press: "Presse",
      mat_press_p: "Voll aushärten, dann kalt pressen, damit der Shape hält.",
      mat_damping: "Dämpfung",
      mat_damping_p: "Drei Lagen Gummi / VDS.",
      mat_sidewalls: "Sidewalls",
      mat_sidewalls_p: "PU, sintered P-tex oder Bambus. Kein Commodity-ABS.",
      mat_finish: "Finish",
      mat_finish_p: "Viele leichte Grinds. Die-Cuts, die du nicht fühlst.",
      mat_graphics: "Graphics",
      mat_graphics_p: "Sublimation, Siebdruck, Die-cut, bedrucktes Furnier, Water Transfer, digital. Gloss oder Matt.",
      water_kicker: "Wasser",
      water_h1: "Custom Waterboard. Eigenes Design.",
      water_lede: "Hardboards fürs Wasser nach Wunsch. Surf, SUP, Foil und mehr. Ein Board oder kurze Serie. Board gestalten.",
      water_who: "carvd. sitzt in der Schweiz. Hardboards fürs Wasser nach Wunsch: Surf, SUP, Foil, Wake, Kite, Wind, Skim. Nur Boards. Ein Board oder eine kurze Serie.",
      water_how: "Board gestalten. Du nennst den Typ, schickst Details und Artwork. Wir antworten innert 48 Stunden. Schreiben: <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>",
      water_q1: "Welche Waterboards baut carvd.?",
      water_a1: "Nur Hardboards. Surf, SUP, Foil, Wake, Kite, Wind, Skim. Keine Inflatables. Kein Kit.",
      water_q2: "Kann ich in der Schweiz ein Surfboard nach Wunsch gestalten?",
      water_a2: "Ja. carvd. sitzt in der Schweiz. Board gestalten ist der Start.",
      water_q3: "Wie lange, und was kostet es?",
      water_a3: "Etwa sechs Wochen nach Bestätigung und Anzahlung. Wir veröffentlichen keine Preise. Nach dem Brief kommt ein Angebot.",
      water_line_kicker: "Die Linie",
      water_line_h2: "Hartboards. Jeder Ride.",
      water_surf_h: "Surfboards",
      water_surf_p: "Shortboard, Fish, Longboard, Gun. Mal. Soft top zum Lernen. EPS- oder PU-Core. Outline, Glass und Fins — gesetzt für die Welle, die du fährst.",
      water_sup_p: "EPS-Schaumcore. Nach Spec. Länge und Volumen mit dir. Deine Graphic auf dem Deck.",
      water_foil_p: "Surf-Foil, Wing, Kite-Foil. Mast und Board mit dir.",
      water_wake_p: "Boot oder Seil. Twin oder direktional.",
      water_wakesurf_p: "Für die Welle hinter dem Boot.",
      water_kite_p: "Twintip oder direktional.",
      water_wind_p: "Freeride bis Welle. Volumen mit dir.",
      water_skim_p: "Shorebreak. Dünn und steif.",
      water_shapes_kicker: "Shapes",
      water_shapes_h2: "Benannte Outlines. Wähl oben einen Typ.",
      water_shapes_lede: "Länge und Volumen setzen wir mit dir.",
      water_shapes_h2_surf: "Surfboard-Outlines.",
      water_shapes_h2_sup: "Hard-SUP-Outlines.",
      water_shapes_h2_foil: "Foil-Outlines.",
      water_shapes_h2_wake: "Wakeboard-Outlines.",
      water_shapes_h2_wakesurf: "Wakesurf-Outlines.",
      water_shapes_h2_kite: "Kiteboard-Outlines.",
      water_shapes_h2_wind: "Windsurf-Outlines.",
      water_shapes_h2_skim: "Skimboard-Outlines.",
      water_short_p: "High-performance, direkt, für kraftvollen Surf",
      water_fish_p: "Breiter, schneller, für kleinere, weichere Wellen",
      water_long_p: "Ruhig, klassisches Trim und Noseriding auf jeder Welle",
      water_gun_p: "Schmal und schnell — für grosse, ernste Swells",
      water_mal_p: "Klassische Mid-length. Mehr Paddle, mehr Glide",
      water_soft_p: "Weiches Deck. Zum Lernen",
      water_sup_allround_p: "Alltagspaddle. Länge und Volumen mit dir",
      water_sup_touring_p: "Länger, hält Kurs",
      water_sup_race_p: "Schmal, für Speed",
      water_sup_surf_p: "Kürzer, für Wellen",
      water_sup_downwind_p: "Für den Downwinder",
      water_foil_surf_p: "Hinter einer Welle",
      water_foil_wing_p: "Für Wing Foil",
      water_foil_kite_p: "Für Kite",
      water_foil_prone_p: "Reinpaddeln ins Foil",
      water_foil_downwind_p: "Downwind-Foil",
      water_wake_twintip_p: "Boot oder Seil",
      water_wake_dir_p: "Mehr Drive",
      water_wakesurf_surf_p: "Mehr Rail, mehr Drive",
      water_wakesurf_skim_p: "Dünner, mehr Slide",
      water_wakesurf_hybrid_p: "Dazwischen",
      water_kite_twintip_p: "Freeride / Freestyle",
      water_kite_dir_p: "Strap oder strapless Welle",
      water_wind_freeride_p: "All-round",
      water_wind_wave_p: "Wave-Sailing",
      water_wind_freestyle_p: "Für Tricks",
      water_wind_slalom_p: "Für Speed",
      water_skim_wave_p: "Shorebreak",
      water_skim_flat_p: "Inland / flach",
      water_start_this: "Dieses Board beginnen",
      water_cta_h2: "Auf dem Wasser beginnen.",
      water_cta_p: "Nenn das Board. Eine Anfrage reicht.",
      con_kicker: "Konstruktion",
      con_h1: "Der Ride steckt in der Spec.",
      con_lede: "Ein Custom-Board ist keine Graphic auf einem Blank. Konstruktion ist das Produkt.",
      con_spec_kicker: "Die Spec",
      con_spec_h2: "Woraus das Board besteht.",
      con_spec_lede: "Sintered Base. Engineered Core. Keramikkanten. Epoxy ohne VOC. Voll ausgehärtet und kalt gepresst.",
      con_cta_h2: "Ein Board, oder eine kurze Linie.",
      con_cta_p: "Kein Workshop-Souvenir. Kein Lagerboard. Wir schreiben in 48 Stunden zurück.",
      about_kicker: "Über uns",
      about_h1: "Custom-Boards für Rider. Kurze Linien für Namen, die mehr als eins brauchen.",
      about_place: "Schweiz.",
      about_p1: "Carvd sitzt in der Schweiz. Wir machen Custom-Snowboards und Watercraft — Shape, Graphic und das Gefühl, mit dir gesetzt.",
      about_p2: "Auf dem Wasser heisst das Hartboards — Surf, SUP, Foil, Wake, Kite, Wind, Skim. Nur Boards. Kein Kit.",
      about_p3: "Wir verkaufen keine Graphic auf einem Blank. Die Spec sind sintered Bases, engineered Cores, Keramikkanten — die volle Liste steht unter <a class=\"inline\" href=\"/pages/construct\">Konstruktion</a>.",
      about_p4: "Eine Anfrage kann ein einzelnes Board sein. Für den Rider, dem das unter den Füssen gehören soll.",
      about_p5: "Wir bauen auch kurze Markenlinien. Shops, Teams, neue Namen. Ein Lauf, hinter dem du stehen kannst — kein Lager voller Restware.",
      about_p6: "Wir veröffentlichen keine Preise. Timeline und Anzahlung stehen in den <a class=\"inline\" href=\"/pages/faq\">FAQ</a>. Schreib an <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>, wir antworten.",
      faq_kicker: "FAQ",
      faq_h1: "Fragen.",
      faq_lede: "Die Fakten einer Custom-Bestellung. Wenn etwas offen bleibt, schreib an <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>.",
      faq_board: "Das Board",
      faq_q_custom: "Was macht ein Board custom?",
      faq_a_custom: "Jedes Board wird nach Spec gebaut. Wir verkaufen keine Lagerboards. Wenn du bei uns bestellst, ist das Board, das ankommt, für diese Bestellung gemacht.",
      faq_q_shapes: "Welche Shapes?",
      faq_a_shapes: "Snow: Classic, Park Camber, Powder, Bluntish. Jede Länge und Breite. Wasser steht unten.",
      faq_q_flex: "Flex",
      faq_a_flex: "Flex ist wählbar. Wenn du unsicher bist, beschreib den Ride. Wir empfehlen einen in der Antwort.",
      faq_q_mat: "Materialien",
      faq_a_mat: "Sintered P-tex 4000 und Electra Bases. Engineered Cores. Kanten mit 48 Rockwell (40 für Rails). Elastomer-Epoxy, null VOC. Voll aushärten, dann kalt pressen. Die volle Spec steht unter <a class=\"inline\" href=\"/pages/construct\">Konstruktion</a>.",
      faq_water: "Wasser",
      faq_q_build: "Was wir bauen",
      faq_a_build: "Hartboards fürs Wasser — Surf, SUP, Foil, Wake, Kite, Wind, Skim. Jeder Typ hat benannte Shapes. Hard SUP mit EPS-Schaumcore. Nur Boards — keine Inflatables, kein Kit.",
      faq_design: "Design",
      faq_q_files: "Dateien",
      faq_a_files: "PNG, JPG, SVG, PDF, AI. Vektor bevorzugt. Raster mit 300 DPI.",
      faq_q_nodesign: "Kein Design?",
      faq_a_nodesign: "Beschreib es. Wir helfen. Wir bestätigen in der Antwort.",
      faq_q_colour: "Farbe",
      faq_a_colour: "Wir matchen Farbe. RGB und CMYK können abweichen. Wenn ein exakter Match zählt, schicken wir einen Proof.",
      faq_order: "Bestellung",
      faq_q_how: "Wie",
      faq_a_how: "Eine Anfrage, oder der <a class=\"inline\" href=\"/pages/start\">Design-Flow</a>. Wir antworten innert 48 Stunden mit Angebot und Timeline.",
      faq_q_time: "Bauzeit",
      faq_a_time: "Etwa sechs Wochen ab Bestätigung und Anzahlung. Oktober–Dezember können acht Wochen sein.",
      faq_q_deposit: "Anzahlung",
      faq_a_deposit: "50 % zum Start. Rest vor dem Versand.",
      faq_q_changes: "Änderungen",
      faq_a_changes: "Änderungen gehen vor der Produktion. Shape und Grösse sind fest, sobald Material geschnitten ist.",
      faq_ship: "Versand",
      faq_q_where: "Wohin",
      faq_a_where: "Wir versenden weltweit. Zölle und Steuern trägt der Käufer.",
      faq_q_returns: "Rückgabe",
      faq_a_returns: "Keine Rückgabe bei Custom, sobald die Produktion läuft — ausser das Board ist defekt oder falsch gebaut. Vierzehn Tage für Mängel. Sieben Tage für Transportschaden. Die <a class=\"inline\" href=\"/pages/refund\">Rückerstattung</a> hat den Rest.",
      ref_kicker: "Rückerstattung",
      ref_h1: "Rückerstattung.",
      ref_updated: "Zuletzt aktualisiert Januar 2026.",
      ref_custom_h: "Custom-Bestellungen",
      ref_custom_p1: "Jedes Board wird auf Bestellung gebaut. Sobald die Produktion läuft, nehmen wir keine Rückgaben oder Rückerstattungen auf Custom-Arbeit an.",
      ref_custom_p2: "Zum Stornieren schreib so früh wie möglich an <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>. Vor der Produktion geht die Anzahlung vollständig zurück. Sobald Material geschnitten und die Presse läuft, ist die Anzahlung nicht erstattbar.",
      ref_defects_h: "Mängel",
      ref_defects_p1: "Kommt das Board mit einem Herstellungsfehler — Delamination, strukturelles Versagen, oder Specs, die wir falsch gebaut haben — reparieren oder ersetzen wir es ohne Kosten. Schreib innert 14 Tagen nach Lieferung, mit Fotos und der Originalbestellung.",
      ref_defects_p2: "Verschleiss, Stösse, Lagerung oder Änderungen nach der Lieferung sind nicht gedeckt.",
      ref_wrong_h: "Falsch gebaut",
      ref_wrong_p: "Haben wir den falschen Shape, die falsche Grösse oder Graphic gegen die bestätigte Bestellung gebaut, bauen oder reparieren wir ohne Kosten. Lies die Bestätigung, bevor die Produktion startet. Melde eine Abweichung sofort.",
      ref_deposit_h: "Anzahlung",
      ref_deposit_p: "50 % zum Beginn. Voll erstattbar, wenn du vor der Produktion stornierst. Nicht erstattbar, sobald Material geschnitten und die Presse läuft. Wird vollständig auf den Restbetrag bei Versand angerechnet.",
      ref_proc_h: "Abwicklung",
      ref_proc_p: "Bewilligte Rückerstattungen gehen innert 5–10 Werktagen auf die ursprüngliche Zahlungsmethode. Ist sie nach 10 Werktagen nicht da, prüfe zuerst die Bank. Fehlt sie weiter, schreib an <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>.",
      ref_ship_h: "Transportschaden",
      ref_ship_p: "Ist das Board unterwegs beschädigt, schreib innert 7 Tagen nach Lieferung mit Fotos vom Schaden und der Verpackung. Wir klären mit dem Carrier Ersatz oder Entschädigung.",
      ref_ret_h: "Rückversand",
      ref_ret_p: "Ist eine Rückgabe wegen Mangel oder falschem Bau bewilligt, schicken wir ein frankiertes Label. Bei jeder anderen bewilligten Rückgabe trägt der Käufer den Rückversand. Nutze einen nachverfolgbaren Dienst. Wir können nicht für ein Paket einstehen, das auf dem Rückweg verloren geht.",
      ref_contact_h: "Kontakt",
      ref_contact_p: "Fragen oder ein Claim: <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>. Wir antworten in der Regel innert 48 Stunden.",
      start_kicker: "Start",
      start_h1: "Board gestalten.",
      start_lede: "Custom Snowboard oder Surfboard. Eigenes Design, Form und Specs. Ein Board oder kurze Serie. Wir schreiben zurück. <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>",
      start_who: "carvd. sitzt in der Schweiz. Wir bauen Custom Snowboards und Waterboards nach Wunsch: Form, Grafik, Specs mit dir. Ein Board oder eine kurze Serie. Kein Lagerboard.",
      start_how: "So läuft es. Du wählst Sport und Shape, schickst Details und Artwork. Wir antworten innert 48 Stunden mit Angebot und Timeline. Schreiben: <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>",
      start_q1: "Was ist ein Custom Board von carvd.?",
      start_a1: "Jedes Board wird auf Spec gebaut. Wir verkaufen keine Lagerboards.",
      start_q2: "Kann ich in der Schweiz ein Snowboard nach Wunsch gestalten?",
      start_a2: "Ja. carvd. sitzt in der Schweiz. Board gestalten ist der Start.",
      start_q3: "Ein Board oder eine Serie?",
      start_a3: "Beides. Ein Board für dich, oder eine kurze Serie für Shop, Team, neuen Namen.",
      start_q4: "Wie lange dauert es?",
      start_a4: "Etwa sechs Wochen nach Bestätigung und Anzahlung. Oktober bis Dezember eher acht.",
      start_q5: "Was kostet es?",
      start_a5: "Wir veröffentlichen keine Preise. Nach dem Brief kommt ein Angebot.",
      flow_1: "Shape",
      flow_2: "Details",
      flow_3: "Senden",
      aria_steps: "Schritte",
      start_line_note: "Eine kurze Markenlinie. Wähl einen Sport, dann was du willst, zum Start.",
      start_leg1: "Schritt 1 — Shape",
      start_sport: "Sport",
      start_what: "Was",
      start_shape: "Shape",
      start_surfboard: "Surfboard",
      start_em_classic: "Direktional, All-Mountain",
      start_em_park: "Twin-tip, Freestyle",
      start_em_powder: "Breit direktional, Backcountry",
      start_em_bluntish: "Hybrid, vielseitig",
      start_em_short: "High-performance",
      start_em_fish: "Breiter, kleinere Wellen",
      start_em_long: "Trim und Noseride",
      start_em_gun: "Schmal, grosse Swells",
      start_em_mal: "Mid-length, mehr Glide",
      start_em_soft: "Weiches Deck, zum Lernen",
      start_em_allround: "Alltagspaddle",
      start_em_touring: "Länger, hält Kurs",
      start_em_race: "Schmal, Speed",
      start_em_supsurf: "Kürzer, für Wellen",
      start_em_downwind: "Downwinder",
      start_em_surffoil: "Hinter einer Welle",
      start_em_wing: "Wing Foil",
      start_em_kitefoil: "Kite",
      start_em_prone: "Reinpaddeln ins Foil",
      start_em_downwindfoil: "Downwind-Foil",
      start_em_twintip: "Boot oder Seil",
      start_em_directional: "Mehr Drive",
      start_em_surfstyle: "Mehr Rail, mehr Drive",
      start_em_skimstyle: "Dünner, mehr Slide",
      start_em_hybrid: "Dazwischen",
      start_em_kitetwin: "Freeride / Freestyle",
      start_em_kitedir: "Strap oder strapless Welle",
      start_em_freeride: "All-round",
      start_em_windwave: "Wave-Sailing",
      start_em_freestyle: "Tricks",
      start_em_slalom: "Speed",
      start_em_skimwave: "Shorebreak",
      start_em_flatland: "Inland / flach",
      start_continue: "Weiter",
      start_leg2: "Schritt 2 — Details",
      start_name: "Name",
      start_email: "E-Mail",
      ph_name: "Dein Name",
      ph_email: "du@studio.ch",
      start_length: "Länge",
      start_width: "Breite",
      start_notsure: "Unsicher",
      start_regular: "Regular",
      start_midwide: "Mid-wide",
      start_wide: "Wide",
      start_fins: "Fin-Setup",
      start_req: "Besondere Anforderungen",
      ph_req: "Flex, Stance, ein Gefühl unter den Füssen — oder leer lassen und den Ride beschreiben.",
      start_notes: "Sonstiges",
      ph_notes: "Timing, eine Referenz, eine Farbe. Ohne Design: hier beschreiben.",
      start_art: "Artwork",
      start_drop: "<strong>Datei ablegen</strong> oder klicken zum Wählen. PNG, JPG, SVG, PDF, AI.",
      start_art_note: "Die Datei bleibt auf deinem Gerät. Häng sie im Entwurf an, oder schick sie in einer Antwort. Vektor bevorzugt; Raster mit 300 DPI.",
      start_back: "Zurück",
      start_leg3: "Schritt 3 — Senden",
      start_send_kicker: "Senden",
      start_draft_h2: "Einen Entwurf öffnen.",
      start_draft_note: "Dein Mailprogramm öffnet diese Notiz an custom@carvdboards.com. Häng die Datei dort an, wenn du eine hast.",
      start_copy: "Entwurf kopieren",
      start_open: "E-Mail-Entwurf öffnen",
      start_success_kicker: "Entwurf",
      start_success_h2: "Die Notiz ist bereit.",
      start_success_p: "Dein Mailprogramm sollte die Notiz an custom@carvdboards.com öffnen. Tut es das nicht, kopier den Entwurf und schreib uns. Häng die Datei in dieser Mail an. Wir ordnen sie <span data-success-email>deiner Adresse</span> zu.",
      start_home: "Zurück zu carvd.",
      start_aside_h: "Was hilft.",
      start_aside_1: "Snow oder Wasser — und was du darauf willst.",
      start_aside_2: "Länge, und Breite oder Fins. «Unsicher» reicht.",
      start_aside_3: "Wie es sich anfühlen soll, wenn Flex offen ist.",
      start_aside_4: "Eine Datei, oder eine Beschreibung. Wir bestätigen in der Antwort.",
      start_aside_note: "Wir antworten innert 48 Stunden mit Angebot und Timeline. <a href=\"/pages/faq\">FAQ</a> · <a href=\"/pages/refund\">Rückerstattung</a>",
      notfound_h1: "Nicht gefunden.",
      notfound_lede: "Diese Seite gibt es nicht.",
      notfound_back: "Zurück zu carvd."
    },

    zh: {
      nav_home: "首页",
      nav_snow: "雪",
      nav_water: "水上",
      nav_construct: "结构",
      nav_about: "关于",
      nav_start: "开始一块板",
      nav_faq: "问答",
      nav_refund: "退款",
      hero_place: "瑞士。",
      hero_line: "你的骑行。你的设计。",
      door_snow: "雪",
      door_water: "水上",
      door_snow_p: "定制滑雪板。",
      door_water_p: "水上硬板。",
      door_go: "进入",
      brands_line: "店铺、队伍、新名字 — 一条短的品牌线。",
      cta_start: "开始一块板",
      footer_place: "瑞士",
      skip: "跳到正文",
      aria_home: "carvd. 首页",
      aria_nav: "主导航",
      aria_lang: "语言",
      aria_menu: "打开菜单",
      construct_line: "结构就是产品。",
      cta_begin: "开始",
      title_home: "carvd. — 定制滑雪板与水上板",
      title_snow: "雪 — carvd.",
      title_water: "定制水上板。你的设计。 | carvd.",
      title_construct: "结构 — carvd.",
      title_about: "关于 — carvd.",
      title_faq: "问答 — carvd.",
      title_refund: "退款 — carvd.",
      title_start: "开始一块板 — carvd.",
      snow_kicker: "雪",
      snow_h1: "定制滑雪板。你的设计。",
      snow_lede: "定制滑雪板。烧结底板，充分固化后冷压。你选板型、图案和手感。我们来做。过程你都知道。",
      snow_who: "carvd. 在瑞士。按你的设计做定制滑雪板。四种板型，你的图案，规格一起定。一块板，或一条短线。不做现货板。",
      snow_how: "从 开始一块板 开始。选板型，发细节和图案。我们 48 小时内回复报价和周期。写信：<a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>",
      snow_q1: "carvd. 的定制滑雪板是什么？",
      snow_a1: "每块滑雪板按规格做。我们不卖现货板。",
      snow_q2: "能在瑞士做自己的滑雪板设计吗？",
      snow_a2: "可以。carvd. 在瑞士。从 开始一块板 开始。",
      snow_q3: "有哪些板型？",
      snow_a3: "Classic、Park Camber、Powder、Bluntish。长度和宽度一起定。",
      snow_q4: "要多久，多少钱？",
      snow_a4: "确认并付定金后大约六周。十月到十二月更接近八周。我们不公布价格。简报之后给你报价。",
      snow_why_kicker: "为何定制",
      snow_why_h2: "目录板是平均值。你的不是。",
      snow_why_1_h: "你骑的板型",
      snow_why_1_p: "四种轮廓。选适合那座山的——不是讨好所有人的中间值。",
      snow_why_2_h: "你的图案",
      snow_why_2_p: "上传图稿，或与我们一起做。顶层是你的标记。不是我们的。",
      snow_why_3_h: "你定规格",
      snow_why_3_p: "软硬、长度、咬边。我们引导。你决定。",
      snow_why_4_h: "一块，或一条线",
      snow_why_4_p: "给一位骑手的一块板。给店铺、队伍、新名字的短系列。",
      snow_shapes_kicker: "板型",
      snow_shapes_h2: "四种轮廓。不同地形。",
      snow_shapes_lede: "选符合你骑法的。长度、腰宽和弧度与你一起定。",
      snow_shape_classic: "指向型，多变地形的控制",
      snow_shape_park: "对称，技巧与道具",
      snow_shape_powder: "宽、浮，适合深雪",
      snow_shape_bluntish: "多用途混合，适应各种条件",
      snow_kreuzli_kicker: "短系列",
      snow_kreuzli_p: "图案已定。你选板型和长度。",
      snow_kreuzli_cta: "在 Ricardo",
      water_kreuzli_kicker: "短系列",
      water_kreuzli_p: "图案已定。你选板型和长度。",
      water_kreuzli_cta: "在 Ricardo",
      snow_journey_kicker: "过程",
      snow_journey_h2: "五步。然后是雪。",
      snow_j1_h: "选板型",
      snow_j1_p: "Classic、Park Camber、Powder 或 Bluntish。不确定时，我们帮你选。",
      snow_j2_h: "设计图案",
      snow_j2_p: "上传图稿，或与我们一起。顶层与底板，开工前定下来。",
      snow_j3_h: "定规格",
      snow_j3_p: "软硬、尺寸、性能。我们和你一起走完。",
      snow_j4_h: "我们来做",
      snow_j4_p: "你的板在做。进度会告诉你。",
      snow_j5_h: "收到，去骑",
      snow_j5_p: "板到了。固定器、打蜡，以及你心里的那座山。",
      snow_build_kicker: "怎么做",
      snow_build_h2: "规格就是产品。",
      snow_build_lede: "烧结底板。工程芯材。陶瓷钢边。完整清单在<a class=\"inline\" href=\"/pages/construct\">结构</a>。",
      snow_cta_h2: "开始一块滑雪板。",
      snow_cta_p: "一块板，或一条短线。一份简述就够。我们会回信。",
      mat_core: "芯材",
      mat_core_p: "泡桐、竹、杨木、软木、碳、蜂窝、钛。软硬来自铺层位置，不只是厚度。",
      mat_fibers: "纤维",
      mat_fibers_p: "高针数三轴玻纤。骑感需要处用预固化碳。",
      mat_edges: "钢边",
      mat_edges_p: "48 Rockwell（滑杆用 40）。陶瓷盘，镜面。",
      mat_bases: "底板",
      mat_bases_p: "烧结 P-tex 4000 与 Electra。硬质挤出底板仅在要求时。",
      mat_epoxy: "环氧",
      mat_epoxy_p: "弹性体，零 VOC。",
      mat_press: "压制",
      mat_press_p: "充分固化，再冷压，让板型稳住。",
      mat_damping: "减震",
      mat_damping_p: "三层橡胶 / VDS。",
      mat_sidewalls: "侧墙",
      mat_sidewalls_p: "PU、烧结 P-tex 或竹。不是通用 ABS。",
      mat_finish: "表面",
      mat_finish_p: "多次轻磨。摸不到的模切。",
      mat_graphics: "图案",
      mat_graphics_p: "热升华、丝印、模切、印刷木皮、水转印、数码。亮面或哑光。",
      water_kicker: "水上",
      water_h1: "定制水上板。你的设计。",
      water_lede: "水上硬板，按你的设计。Surf、SUP、Foil 等。一块板，或一条短线。开始一块板。",
      water_who: "carvd. 在瑞士。按你的设计做水上硬板：surf、SUP、foil、wake、kite、wind、skim。只做板。一块板，或一条短线。",
      water_how: "从 开始一块板 开始。说类型，发细节和图案。我们 48 小时内回复。写信：<a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>",
      water_q1: "carvd. 做哪些水上板？",
      water_a1: "只做硬板。Surf、SUP、foil、wake、kite、wind、skim。不做充气板。不做套装。",
      water_q2: "能在瑞士做自己的冲浪板设计吗？",
      water_a2: "可以。carvd. 在瑞士。从 开始一块板 开始。",
      water_q3: "要多久，多少钱？",
      water_a3: "确认并付定金后大约六周。我们不公布价格。简报之后给你报价。",
      water_line_kicker: "产品线",
      water_line_h2: "硬板。每一种骑法。",
      water_surf_h: "冲浪板",
      water_surf_p: "Shortboard、Fish、Longboard、Gun。Mal。Soft top 用于入门。EPS 或 PU 芯。轮廓、玻纤与鳍——按你骑的浪来定。",
      water_sup_p: "EPS 泡沫芯。按规格做。长度与容积与你一起定。甲板是你的图案。",
      water_foil_p: "冲浪箔、翼、风筝箔。桅与板与你一起定。",
      water_wake_p: "船拖或缆绳。双尖或指向。",
      water_wakesurf_p: "给船尾的浪。",
      water_kite_p: "双尖或指向。",
      water_wind_p: "从自由滑到浪。容积与你一起定。",
      water_skim_p: "岸边碎浪。薄而硬。",
      water_shapes_kicker: "板型",
      water_shapes_h2: "命名轮廓。在上方选一种。",
      water_shapes_lede: "长度与容积与你一起定。",
      water_shapes_h2_surf: "冲浪板轮廓。",
      water_shapes_h2_sup: "Hard SUP 轮廓。",
      water_shapes_h2_foil: "箔板轮廓。",
      water_shapes_h2_wake: "尾波板轮廓。",
      water_shapes_h2_wakesurf: "尾波冲浪轮廓。",
      water_shapes_h2_kite: "风筝板轮廓。",
      water_shapes_h2_wind: "风帆板轮廓。",
      water_shapes_h2_skim: "撇板轮廓。",
      water_short_p: "高性能、灵敏，为有力的浪而做",
      water_fish_p: "更宽、更快，适合较小、较软的浪",
      water_long_p: "顺、经典走线与鼻骑，适合各种浪",
      water_gun_p: "窄而快——给大而认真的涌浪",
      water_mal_p: "经典中长。更多划水，更多滑行",
      water_soft_p: "软甲板。为学习而做",
      water_sup_allround_p: "日常桨。长度与容积与你一起定",
      water_sup_touring_p: "更长，走线稳",
      water_sup_race_p: "窄，为速度",
      water_sup_surf_p: "更短，给浪",
      water_sup_downwind_p: "给顺风",
      water_foil_surf_p: "跟在浪后",
      water_foil_wing_p: "给翼箔",
      water_foil_kite_p: "给风筝",
      water_foil_prone_p: "划入箔态",
      water_foil_downwind_p: "顺风箔",
      water_wake_twintip_p: "船拖或缆绳",
      water_wake_dir_p: "更多推进",
      water_wakesurf_surf_p: "更多边线，更多推进",
      water_wakesurf_skim_p: "更薄，更多滑",
      water_wakesurf_hybrid_p: "两者之间",
      water_kite_twintip_p: "自由滑 / 自由式",
      water_kite_dir_p: "脚绳或无绳浪",
      water_wind_freeride_p: "全能",
      water_wind_wave_p: "浪上风帆",
      water_wind_freestyle_p: "给技巧",
      water_wind_slalom_p: "给速度",
      water_skim_wave_p: "岸边碎浪",
      water_skim_flat_p: "内陆 / 平水",
      water_start_this: "开始这块板",
      water_cta_h2: "从水上开始。",
      water_cta_p: "说出这块板。一份简述就够。",
      con_kicker: "结构",
      con_h1: "骑感在规格里。",
      con_lede: "定制板不是空白板上的图案。结构就是产品。",
      con_spec_kicker: "规格",
      con_spec_h2: "板由什么做成。",
      con_spec_lede: "烧结底板。工程芯材。陶瓷钢边。无 VOC 环氧。充分固化后冷压锁定。",
      con_cta_h2: "一块板，或一条短线。",
      con_cta_p: "不是工坊纪念品。不是库存板。我们 48 小时内回信。",
      about_kicker: "关于",
      about_h1: "给骑手的定制板。给需要不止一块的名字的短系列。",
      about_place: "瑞士。",
      about_p1: "Carvd 在瑞士。我们做定制滑雪板与水上板——板型、图案和手感，与你一起定。",
      about_p2: "水上是硬板——冲浪、SUP、箔、尾波、风筝、风帆、撇板。只做板。不是套装。",
      about_p3: "我们不卖空白板上的图案。规格是烧结底板、工程芯材、陶瓷钢边——完整清单在<a class=\"inline\" href=\"/pages/construct\">结构</a>。",
      about_p4: "一份简述可以是一块板。骑手希望脚下的东西是自己的。",
      about_p5: "我们也做短品牌线。店铺、队伍、新名字。一条你能站得住的系列——不是一仓库剩货。",
      about_p6: "我们不公布价格。周期与定金在<a class=\"inline\" href=\"/pages/faq\">问答</a>。写信到 <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>，我们会回。",
      faq_kicker: "问答",
      faq_h1: "问题。",
      faq_lede: "定制订单的事实。若还有未决，写信到 <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>。",
      faq_board: "板",
      faq_q_custom: "怎样算定制板？",
      faq_a_custom: "每块板按规格做。我们不卖库存板。向我们下单，送到的板就是为那一单做的。",
      faq_q_shapes: "哪些板型？",
      faq_a_shapes: "雪：Classic、Park Camber、Powder、Bluntish。任意长度与宽度。水上见下。",
      faq_q_flex: "软硬",
      faq_a_flex: "软硬可选。不确定就描述骑法。回信时我们会建议。",
      faq_q_mat: "材料",
      faq_a_mat: "烧结 P-tex 4000 与 Electra 底板。工程芯材。钢边 48 Rockwell（滑杆用 40）。弹性体环氧，零 VOC。充分固化后冷压。完整规格在<a class=\"inline\" href=\"/pages/construct\">结构</a>。",
      faq_water: "水上",
      faq_q_build: "我们做什么",
      faq_a_build: "水上硬板——冲浪、SUP、箔、尾波、风筝、风帆、撇板。每种都有命名板型。Hard SUP 用 EPS 泡沫芯。只做板——无充气、无套装。",
      faq_design: "设计",
      faq_q_files: "文件",
      faq_a_files: "PNG、JPG、SVG、PDF、AI。优先矢量。位图 300 DPI。",
      faq_q_nodesign: "没有设计？",
      faq_a_nodesign: "描述即可。我们帮。回信里确认。",
      faq_q_colour: "颜色",
      faq_a_colour: "我们对照颜色。RGB 与 CMYK 可能有差。若必须精确，我们发样张。",
      faq_order: "订单",
      faq_q_how: "怎么做",
      faq_a_how: "一份简述，或<a class=\"inline\" href=\"/pages/start\">设计流程</a>。我们 48 小时内回复报价与周期。",
      faq_q_time: "制作时间",
      faq_a_time: "确认与定金后大约六周。十月至十二月可能八周。",
      faq_q_deposit: "定金",
      faq_a_deposit: "先付 50%。出货前付清余款。",
      faq_q_changes: "更改",
      faq_a_changes: "开工前可以改。材料切开后，板型与尺寸锁定。",
      faq_ship: "运输",
      faq_q_where: "送到哪",
      faq_a_where: "全球发货。关税与税费由买方承担。",
      faq_q_returns: "退货",
      faq_a_returns: "定制一旦开工不退——除非板有缺陷或做错。缺陷十四天。运输损坏七天。其余见<a class=\"inline\" href=\"/pages/refund\">退款</a>。",
      ref_kicker: "退款",
      ref_h1: "退款。",
      ref_updated: "最近更新于 2026 年 1 月。",
      ref_custom_h: "定制订单",
      ref_custom_p1: "每块板按单制作。一旦开工，定制不接受退货或退款。",
      ref_custom_p2: "要取消，尽快写信到 <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>。开工前取消，定金全退。材料切开、压制开始后，定金不退。",
      ref_defects_h: "缺陷",
      ref_defects_p1: "若板到货有制造缺陷——分层、结构失效，或规格做错——我们免费修理或更换。收货 14 天内写信，附照片与原订单。",
      ref_defects_p2: "磨损、撞击、存放，或收货后的改动，不在范围内。",
      ref_wrong_h: "做错",
      ref_wrong_p: "若我们按已确认订单做错了板型、尺寸或图案，免费重做或修理。开工前请读确认。发现不符立刻指出。",
      ref_deposit_h: "定金",
      ref_deposit_p: "先付 50%。开工前取消可全退。材料切开、压制开始后不退。出货时全额抵扣余款。",
      ref_proc_h: "处理",
      ref_proc_p: "已批准的退款在 5–10 个工作日内退回原支付方式。若 10 个工作日后仍未到，先查银行。仍没有，写信到 <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>。",
      ref_ship_h: "运输损坏",
      ref_ship_p: "若板在运输中损坏，收货 7 天内写信，附损坏与包装照片。我们与承运方协商更换或赔偿。",
      ref_ret_h: "退货运费",
      ref_ret_p: "因缺陷或做错而批准退货时，我们提供预付面单。其他已批准退货，回程运费由买方承担。请用可追踪服务。回程丢失的包裹，我们无法负责。",
      ref_contact_h: "联系",
      ref_contact_p: "问题或索赔：<a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>。我们争取 48 小时内回复。",
      start_kicker: "开始",
      start_h1: "开始一块板。",
      start_lede: "三步。板型、细节，然后一份草稿发到 <a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>。周期与定金见<a class=\"inline\" href=\"/pages/faq\">问答</a>。",
      start_who: "carvd. 在瑞士。按你的设计做定制滑雪板和水上板：板型、图形、规格一起定。一块板，或一条短线。不做现货板。",
      start_how: "先选运动和板型，再发细节和图案。我们 48 小时内回复报价和周期。写信：<a class=\"inline\" href=\"mailto:custom@carvdboards.com\">custom@carvdboards.com</a>",
      start_q1: "carvd. 的定制板是什么？",
      start_a1: "每块板按规格做。我们不卖现货板。",
      start_q2: "能在瑞士做自己的滑雪板设计吗？",
      start_a2: "可以。carvd. 在瑞士。从 开始一块板 开始。",
      start_q3: "一块板还是一条线？",
      start_a3: "都行。给你一块板，或给店、队、新名字做一条短线。",
      start_q4: "要多久？",
      start_a4: "确认并付定金后大约六周。十月到十二月更接近八周。",
      start_q5: "多少钱？",
      start_a5: "我们不公布价格。简报之后给你报价。",
      flow_1: "板型",
      flow_2: "细节",
      flow_3: "发送",
      aria_steps: "步骤",
      start_line_note: "一条短品牌线。先选运动，再选你要的，即可开始。",
      start_leg1: "第 1 步 — 板型",
      start_sport: "运动",
      start_what: "种类",
      start_shape: "板型",
      start_surfboard: "Surfboard",
      start_em_classic: "指向，全山",
      start_em_park: "双尖，自由式",
      start_em_powder: "宽指向，野雪",
      start_em_bluntish: "混合，多用途",
      start_em_short: "高性能",
      start_em_fish: "更宽，较小的浪",
      start_em_long: "走线与鼻骑",
      start_em_gun: "窄，大涌浪",
      start_em_mal: "中长，更多滑行",
      start_em_soft: "软甲板，用于学习",
      start_em_allround: "日常桨",
      start_em_touring: "更长，走线稳",
      start_em_race: "窄，速度",
      start_em_supsurf: "更短，给浪",
      start_em_downwind: "顺风",
      start_em_surffoil: "跟在浪后",
      start_em_wing: "翼箔",
      start_em_kitefoil: "风筝",
      start_em_prone: "划入箔态",
      start_em_downwindfoil: "顺风箔",
      start_em_twintip: "船拖或缆绳",
      start_em_directional: "更多推进",
      start_em_surfstyle: "更多边线，更多推进",
      start_em_skimstyle: "更薄，更多滑",
      start_em_hybrid: "两者之间",
      start_em_kitetwin: "自由滑 / 自由式",
      start_em_kitedir: "脚绳或无绳浪",
      start_em_freeride: "全能",
      start_em_windwave: "浪上风帆",
      start_em_freestyle: "技巧",
      start_em_slalom: "速度",
      start_em_skimwave: "岸边碎浪",
      start_em_flatland: "内陆 / 平水",
      start_continue: "继续",
      start_leg2: "第 2 步 — 细节",
      start_name: "姓名",
      start_email: "邮箱",
      ph_name: "你的姓名",
      ph_email: "you@studio.ch",
      start_length: "长度",
      start_width: "宽度",
      start_notsure: "不确定",
      start_regular: "Regular",
      start_midwide: "Mid-wide",
      start_wide: "Wide",
      start_fins: "鳍配置",
      start_req: "特殊要求",
      ph_req: "软硬、站姿、脚下的感觉——或留空，描述骑法。",
      start_notes: "其他",
      ph_notes: "时间、参考、颜色。没有设计就写在这里。",
      start_art: "图稿",
      start_drop: "<strong>拖入文件</strong>或点击选择。PNG、JPG、SVG、PDF、AI。",
      start_art_note: "文件留在你的设备上。在打开的草稿里附上，或在回复中发送。优先矢量；位图 300 DPI。",
      start_back: "返回",
      start_leg3: "第 3 步 — 发送",
      start_send_kicker: "发送",
      start_draft_h2: "打开一份草稿。",
      start_draft_note: "你的邮件程序会打开这封给 custom@carvdboards.com 的草稿。若有文件，在那里附上。",
      start_copy: "复制草稿",
      start_open: "打开邮件草稿",
      start_success_kicker: "草稿",
      start_success_h2: "草稿已备好。",
      start_success_p: "你的邮件程序应打开给 custom@carvdboards.com 的草稿。若没有，复制草稿并写信给我们。在那封邮件里附上文件。我们会把它对应到 <span data-success-email>你的地址</span>。",
      start_home: "回到 carvd.",
      start_aside_h: "有用的信息。",
      start_aside_1: "雪或水上——以及你要哪一种。",
      start_aside_2: "长度，以及宽度或鳍。「不确定」即可。",
      start_aside_3: "若软硬未定，写下它应有的感觉。",
      start_aside_4: "一个文件，或一段描述。我们在回信中确认。",
      start_aside_note: "我们 48 小时内回复报价与周期。<a href=\"/pages/faq\">问答</a> · <a href=\"/pages/refund\">退款</a>",
      notfound_h1: "未找到。",
      notfound_lede: "没有这个页面。",
      notfound_back: "回到 carvd."
    }
  };

  var MSG = {
    en: {
      pick_sport: "Pick snow or water.",
      pick_water: "Pick what you want on water.",
      pick_shape: "Pick a shape.",
      complete: "Please complete the required fields.",
      copied: "Copied",
      copy_draft: "Copy draft",
      attach_none: "No file selected. Attach one in the mail, or send it in a reply.",
      attach_named: "Attach “{file}” in the mail. It is not sent from this page.",
      none_selected: "none selected",
      unit_cm: "(cm)",
      draft_to: "To",
      draft_subject: "Subject",
      draft_name: "Name",
      draft_email: "Email",
      draft_sport: "Sport",
      draft_what: "What",
      draft_shape: "Shape",
      draft_qty: "Quantity: a short branded line",
      draft_length_cm: "Length (cm)",
      draft_length: "Length",
      draft_width: "Width",
      draft_fins: "Fin setup",
      draft_req: "Special requirements",
      draft_notes: "Anything else",
      draft_art: "Artwork file",
      draft_art_note: "(attach in this email if you have it)",
      draft_subject_prefix: "Board brief — ",
      draft_brief: "brief"
    },
    de: {
      pick_sport: "Wähl Snow oder Wasser.",
      pick_water: "Wähl, was du auf dem Wasser willst.",
      pick_shape: "Wähl einen Shape.",
      complete: "Bitte die Pflichtfelder ausfüllen.",
      copied: "Kopiert",
      copy_draft: "Entwurf kopieren",
      attach_none: "Keine Datei gewählt. Häng eine in der Mail an, oder schick sie in einer Antwort.",
      attach_named: "Häng „{file}“ in der Mail an. Sie wird von dieser Seite nicht mitgeschickt.",
      none_selected: "keine gewählt",
      unit_cm: "(cm)",
      draft_to: "An",
      draft_subject: "Betreff",
      draft_name: "Name",
      draft_email: "E-Mail",
      draft_sport: "Sport",
      draft_what: "Was",
      draft_shape: "Shape",
      draft_qty: "Menge: eine kurze Markenlinie",
      draft_length_cm: "Länge (cm)",
      draft_length: "Länge",
      draft_width: "Breite",
      draft_fins: "Fin-Setup",
      draft_req: "Besondere Anforderungen",
      draft_notes: "Sonstiges",
      draft_art: "Artwork-Datei",
      draft_art_note: "(in dieser Mail anhängen, falls vorhanden)",
      draft_subject_prefix: "Board-Brief — ",
      draft_brief: "Anfrage"
    },
    zh: {
      pick_sport: "请选雪或水上。",
      pick_water: "请选你要的水上板。",
      pick_shape: "请选一个板型。",
      complete: "请填写必填项。",
      copied: "已复制",
      copy_draft: "复制草稿",
      attach_none: "未选文件。在邮件中附上，或在回复中发送。",
      attach_named: "请在邮件中附上“{file}”。本页不会发送它。",
      none_selected: "未选择",
      unit_cm: "(cm)",
      draft_to: "收件人",
      draft_subject: "主题",
      draft_name: "姓名",
      draft_email: "邮箱",
      draft_sport: "运动",
      draft_what: "种类",
      draft_shape: "板型",
      draft_qty: "数量：一条短品牌线",
      draft_length_cm: "长度 (cm)",
      draft_length: "长度",
      draft_width: "宽度",
      draft_fins: "鳍配置",
      draft_req: "特殊要求",
      draft_notes: "其他",
      draft_art: "图稿文件",
      draft_art_note: "（若有，请在此邮件中附上）",
      draft_subject_prefix: "板简述 — ",
      draft_brief: "简述"
    }
  };

  var HINTS = {
    en: {
      Classic: "A starting point: 156 cm, stiff, directional. Change it if the ride is different.",
      "Park Camber": "A starting point: 155 cm, medium, twin. Change it if the ride is different.",
      Powder: "A starting point: 155 cm, medium-stiff, wide, directional. Change it if the ride is different.",
      Bluntish: "A starting point: 155 cm, medium, hybrid. Change it if the ride is different.",
      Shortboard: "A starting point: 6′2″, stiff. Change it if the ride is different.",
      Fish: "A starting point: 5′10″, soft. Change it if the ride is different.",
      Longboard: "A starting point: 9′0″, medium. Change it if the ride is different.",
      Gun: "A starting point: 7′6″, stiff. Change it if the ride is different.",
      Mal: "A starting point: 9′2″, medium. Change it if the ride is different.",
      "Soft top": "A starting point: 8′0″, soft. Change it if the ride is different.",
      "All-round": "A starting point: 10′6″. Change it if the ride is different.",
      Touring: "A starting point: 12′6″. Change it if the ride is different.",
      Race: "A starting point: 14′0″. Change it if the ride is different.",
      Surf: "A starting point: 9′0″. Change it if the ride is different.",
      Downwind: "A starting point: 14′0″. Change it if the ride is different.",
      "Surf foil": "A starting point: 4′8″. Change it if the ride is different.",
      Wing: "A starting point: 5′4″. Change it if the ride is different.",
      "Kite foil": "A starting point: 4′4″. Change it if the ride is different.",
      Prone: "A starting point: 4′6″. Change it if the ride is different.",
      "Downwind foil": "A starting point: 6′0″. Change it if the ride is different.",
      "Twin-tip": "A starting point: 142. Change it if the ride is different.",
      Directional: "A starting point: 144. Change it if the ride is different.",
      "Surf-style": "A starting point: 4′10″. Change it if the ride is different.",
      "Skim-style": "A starting point: 4′6″. Change it if the ride is different.",
      Hybrid: "A starting point: 4′8″. Change it if the ride is different.",
      Twintip: "A starting point: 136. Change it if the ride is different.",
      Freeride: "A starting point: 115 L. Change it if the ride is different.",
      Wave: "A starting point: 85 L. Change it if the ride is different.",
      "Skimboard Wave": "A starting point: 52″. Change it if the ride is different.",
      Freestyle: "A starting point: 95 L. Change it if the ride is different.",
      Slalom: "A starting point: 125 L. Change it if the ride is different.",
      Flatland: "A starting point: 48″. Change it if the ride is different.",
      "Hard SUP": "A starting point: 10′6″. Change it if the ride is different.",
      Foil: "A starting point: 4′8″. Change it if the ride is different.",
      Wakeboard: "A starting point: 142. Change it if the ride is different.",
      Wakesurf: "A starting point: 4′8″. Change it if the ride is different.",
      Kiteboard: "A starting point: 136. Change it if the ride is different.",
      Windsurf: "A starting point: 115 L. Change it if the ride is different.",
      Skimboard: "A starting point: 52″. Change it if the ride is different."
    },
    de: {
      Classic: "Ausgangspunkt: 156 cm, steif, direktional. Ändern, wenn der Ride anders ist.",
      "Park Camber": "Ausgangspunkt: 155 cm, mittel, twin. Ändern, wenn der Ride anders ist.",
      Powder: "Ausgangspunkt: 155 cm, mittelsteif, breit, direktional. Ändern, wenn der Ride anders ist.",
      Bluntish: "Ausgangspunkt: 155 cm, mittel, hybrid. Ändern, wenn der Ride anders ist.",
      Shortboard: "Ausgangspunkt: 6′2″, steif. Ändern, wenn der Ride anders ist.",
      Fish: "Ausgangspunkt: 5′10″, weich. Ändern, wenn der Ride anders ist.",
      Longboard: "Ausgangspunkt: 9′0″, mittel. Ändern, wenn der Ride anders ist.",
      Gun: "Ausgangspunkt: 7′6″, steif. Ändern, wenn der Ride anders ist.",
      Mal: "Ausgangspunkt: 9′2″, mittel. Ändern, wenn der Ride anders ist.",
      "Soft top": "Ausgangspunkt: 8′0″, weich. Ändern, wenn der Ride anders ist.",
      "All-round": "Ausgangspunkt: 10′6″. Ändern, wenn der Ride anders ist.",
      Touring: "Ausgangspunkt: 12′6″. Ändern, wenn der Ride anders ist.",
      Race: "Ausgangspunkt: 14′0″. Ändern, wenn der Ride anders ist.",
      Surf: "Ausgangspunkt: 9′0″. Ändern, wenn der Ride anders ist.",
      Downwind: "Ausgangspunkt: 14′0″. Ändern, wenn der Ride anders ist.",
      "Surf foil": "Ausgangspunkt: 4′8″. Ändern, wenn der Ride anders ist.",
      Wing: "Ausgangspunkt: 5′4″. Ändern, wenn der Ride anders ist.",
      "Kite foil": "Ausgangspunkt: 4′4″. Ändern, wenn der Ride anders ist.",
      Prone: "Ausgangspunkt: 4′6″. Ändern, wenn der Ride anders ist.",
      "Downwind foil": "Ausgangspunkt: 6′0″. Ändern, wenn der Ride anders ist.",
      "Twin-tip": "Ausgangspunkt: 142. Ändern, wenn der Ride anders ist.",
      Directional: "Ausgangspunkt: 144. Ändern, wenn der Ride anders ist.",
      "Surf-style": "Ausgangspunkt: 4′10″. Ändern, wenn der Ride anders ist.",
      "Skim-style": "Ausgangspunkt: 4′6″. Ändern, wenn der Ride anders ist.",
      Hybrid: "Ausgangspunkt: 4′8″. Ändern, wenn der Ride anders ist.",
      Twintip: "Ausgangspunkt: 136. Ändern, wenn der Ride anders ist.",
      Freeride: "Ausgangspunkt: 115 L. Ändern, wenn der Ride anders ist.",
      Wave: "Ausgangspunkt: 85 L. Ändern, wenn der Ride anders ist.",
      "Skimboard Wave": "Ausgangspunkt: 52″. Ändern, wenn der Ride anders ist.",
      Freestyle: "Ausgangspunkt: 95 L. Ändern, wenn der Ride anders ist.",
      Slalom: "Ausgangspunkt: 125 L. Ändern, wenn der Ride anders ist.",
      Flatland: "Ausgangspunkt: 48″. Ändern, wenn der Ride anders ist.",
      "Hard SUP": "Ausgangspunkt: 10′6″. Ändern, wenn der Ride anders ist.",
      Foil: "Ausgangspunkt: 4′8″. Ändern, wenn der Ride anders ist.",
      Wakeboard: "Ausgangspunkt: 142. Ändern, wenn der Ride anders ist.",
      Wakesurf: "Ausgangspunkt: 4′8″. Ändern, wenn der Ride anders ist.",
      Kiteboard: "Ausgangspunkt: 136. Ändern, wenn der Ride anders ist.",
      Windsurf: "Ausgangspunkt: 115 L. Ändern, wenn der Ride anders ist.",
      Skimboard: "Ausgangspunkt: 52″. Ändern, wenn der Ride anders ist."
    },
    zh: {
      Classic: "起点：156 cm，硬，指向。若骑法不同，再改。",
      "Park Camber": "起点：155 cm，中等，双尖。若骑法不同，再改。",
      Powder: "起点：155 cm，中硬，宽，指向。若骑法不同，再改。",
      Bluntish: "起点：155 cm，中等，混合。若骑法不同，再改。",
      Shortboard: "起点：6′2″，硬。若骑法不同，再改。",
      Fish: "起点：5′10″，软。若骑法不同，再改。",
      Longboard: "起点：9′0″，中等。若骑法不同，再改。",
      Gun: "起点：7′6″，硬。若骑法不同，再改。",
      Mal: "起点：9′2″，中等。若骑法不同，再改。",
      "Soft top": "起点：8′0″，软。若骑法不同，再改。",
      "All-round": "起点：10′6″。若骑法不同，再改。",
      Touring: "起点：12′6″。若骑法不同，再改。",
      Race: "起点：14′0″。若骑法不同，再改。",
      Surf: "起点：9′0″。若骑法不同，再改。",
      Downwind: "起点：14′0″。若骑法不同，再改。",
      "Surf foil": "起点：4′8″。若骑法不同，再改。",
      Wing: "起点：5′4″。若骑法不同，再改。",
      "Kite foil": "起点：4′4″。若骑法不同，再改。",
      Prone: "起点：4′6″。若骑法不同，再改。",
      "Downwind foil": "起点：6′0″。若骑法不同，再改。",
      "Twin-tip": "起点：142。若骑法不同，再改。",
      Directional: "起点：144。若骑法不同，再改。",
      "Surf-style": "起点：4′10″。若骑法不同，再改。",
      "Skim-style": "起点：4′6″。若骑法不同，再改。",
      Hybrid: "起点：4′8″。若骑法不同，再改。",
      Twintip: "起点：136。若骑法不同，再改。",
      Freeride: "起点：115 L。若骑法不同，再改。",
      Wave: "起点：85 L。若骑法不同，再改。",
      "Skimboard Wave": "起点：52″。若骑法不同，再改。",
      Freestyle: "起点：95 L。若骑法不同，再改。",
      Slalom: "起点：125 L。若骑法不同，再改。",
      Flatland: "起点：48″。若骑法不同，再改。",
      "Hard SUP": "起点：10′6″。若骑法不同，再改。",
      Foil: "起点：4′8″。若骑法不同，再改。",
      Wakeboard: "起点：142。若骑法不同，再改。",
      Wakesurf: "起点：4′8″。若骑法不同，再改。",
      Kiteboard: "起点：136。若骑法不同，再改。",
      Windsurf: "起点：115 L。若骑法不同，再改。",
      Skimboard: "起点：52″。若骑法不同，再改。"
    }
  };

  function msg() {
    return MSG[currentLang] || MSG.en;
  }

  function applyLang(code) {
    var pack = STR[code] || STR.en;
    currentLang = STR[code] ? code : "en";
    html.lang = currentLang;
    document.querySelectorAll("[data-i18n]").forEach(function (el) {
      var key = el.getAttribute("data-i18n");
      if (pack[key]) el.textContent = pack[key];
    });
    document.querySelectorAll("[data-i18n-html]").forEach(function (el) {
      var key = el.getAttribute("data-i18n-html");
      if (pack[key]) el.innerHTML = pack[key];
    });
    document.querySelectorAll("[data-i18n-placeholder]").forEach(function (el) {
      var key = el.getAttribute("data-i18n-placeholder");
      if (pack[key]) el.setAttribute("placeholder", pack[key]);
    });
    document.querySelectorAll("[data-i18n-aria]").forEach(function (el) {
      var key = el.getAttribute("data-i18n-aria");
      if (pack[key]) el.setAttribute("aria-label", pack[key]);
    });
    var titleEl = document.querySelector("[data-i18n-title]");
    if (titleEl) {
      var tkey = titleEl.getAttribute("data-i18n-title");
      if (pack[tkey]) document.title = pack[tkey];
    }
    document.querySelectorAll(".lang button").forEach(function (btn) {
      btn.setAttribute("aria-pressed", String(btn.getAttribute("data-lang") === currentLang));
    });
    try { localStorage.setItem("carvd-lang", currentLang); } catch (e) {}
    applyFormLang();
  }

  function chooseLang(code) {
    applyLang(code);
    var dest = urlForLang(code);
    if (dest && dest !== location.pathname + location.search + location.hash) {
      location.assign(dest);
    }
  }
  langBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      chooseLang(btn.getAttribute("data-lang"));
    });
  });

  if (nav && !nav.querySelector("[data-nav-start]")) {
    var start = document.createElement("a");
    start.href = "/pages/start";
    start.setAttribute("data-nav-start", "");
    start.setAttribute("data-i18n", "nav_start");
    start.textContent = (STR[currentLang] && STR[currentLang].nav_start) || STR.de.nav_start;
    nav.appendChild(start);
  }
  var headerLang = document.querySelector(".header-tools .lang");
  if (nav && headerLang && !nav.querySelector("[data-nav-lang]")) {
    var langClone = headerLang.cloneNode(true);
    langClone.setAttribute("data-nav-lang", "");
    langClone.querySelectorAll("button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        chooseLang(btn.getAttribute("data-lang"));
      });
    });
    nav.appendChild(langClone);
  }

  function pathLang() {
    var p = (location.pathname || "/").toLowerCase();
    if (p === "/en" || p.indexOf("/en/") === 0) return "en";
    if (p === "/zh-cn" || p.indexOf("/zh-cn/") === 0) return "zh";
    if (p === "/zh" || p.indexOf("/zh/") === 0) return "zh";
    return null;
  }
  function stripLocalePrefix(p) {
    var s = p.replace(/^\/(en|zh-cn|zh)(?=\/|$)/i, "");
    return s || "/";
  }
  var zhPrefixLive = false;
  try {
    fetch("/zh/", { method: "HEAD", redirect: "manual" }).then(function (r) {
      zhPrefixLive = r.status >= 200 && r.status < 400;
    }).catch(function () {});
  } catch (e) {}
  function urlForLang(code) {
    var p = location.pathname || "/";
    if (/\.html?$/i.test(p)) return null;
    var rest = stripLocalePrefix(p);
    var shop = rest === "/" || rest.indexOf("/pages/") === 0;
    if (!shop) return null;
    var dest;
    if (code === "en") dest = "/en" + (rest === "/" ? "" : rest);
    else if (code === "zh") {
      if (!zhPrefixLive && pathLang() !== "zh") return null;
      dest = "/zh" + (rest === "/" ? "" : rest);
    } else dest = rest;
    dest = dest + location.search + location.hash;
    if (dest === p + location.search + location.hash) return null;
    return dest;
  }
  var saved = null;
  try { saved = localStorage.getItem("carvd-lang"); } catch (e) {}
  if (saved === "fr") saved = "en";
  var fromPath = pathLang();
  if (fromPath) applyLang(fromPath);
  else if (saved && STR[saved]) applyLang(saved);

  if (header) {
    var onScroll = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 8);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  if (toggle && nav) {
    toggle.addEventListener("click", function () {
      var open = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", String(!open));
      nav.classList.toggle("is-open", !open);
      document.body.classList.toggle("nav-open", !open);
    });
    nav.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        toggle.setAttribute("aria-expanded", "false");
        nav.classList.remove("is-open");
        document.body.classList.remove("nav-open");
      });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && nav.classList.contains("is-open")) {
        toggle.setAttribute("aria-expanded", "false");
        nav.classList.remove("is-open");
        document.body.classList.remove("nav-open");
        toggle.focus();
      }
    });
  }

  var PLACE = {
    Classic: "156",
    "Park Camber": "155",
    Powder: "155",
    Bluntish: "155",
    Shortboard: "6'2\"",
    Fish: "5'10\"",
    Longboard: "9'0\"",
    Gun: "7'6\"",
    Mal: "9'2\"",
    "Soft top": "8'0\"",
    "All-round": "10'6\"",
    Touring: "12'6\"",
    Race: "14'0\"",
    Surf: "9'0\"",
    Downwind: "14'0\"",
    "Surf foil": "4'8\"",
    Wing: "5'4\"",
    "Kite foil": "4'4\"",
    Prone: "4'6\"",
    "Downwind foil": "6'0\"",
    "Twin-tip": "142",
    Directional: "144",
    "Surf-style": "4'10\"",
    "Skim-style": "4'6\"",
    Hybrid: "4'8\"",
    Twintip: "136",
    Freeride: "115 L",
    Wave: "85 L",
    "Skimboard Wave": "52\"",
    Freestyle: "95 L",
    Slalom: "125 L",
    Flatland: "48\"",
    "Hard SUP": "10'6\"",
    Foil: "4'8\"",
    Wakeboard: "142",
    Wakesurf: "4'8\"",
    Kiteboard: "136",
    Windsurf: "115 L",
    Skimboard: "52\""
  };

  var MAIL = "custom@carvdboards.com";

  var form = document.querySelector("form.project");
  if (form) {
    var drop = form.querySelector(".drop");
    var file = form.querySelector('input[type="file"]');
    var fileName = form.querySelector(".file-name");
    var success = document.querySelector(".success");
    var sportInputs = form.querySelectorAll('input[name="sport"]');
    var whatInputs = form.querySelectorAll('input[name="what"]');
    var shapeInputs = form.querySelectorAll('input[name="shape"]');
    var shapeGate = document.getElementById("shape-gate");
    var sportGate = document.getElementById("sport-gate");
    var whatGate = document.getElementById("what-gate");
    var specHint = document.getElementById("spec-hint");
    var lengthInput = document.getElementById("length");
    var lengthUnit = document.getElementById("length-unit");
    var fieldLength = document.getElementById("field-length");
    var fieldWidth = document.getElementById("field-width");
    var fieldFins = document.getElementById("field-fins");
    var draftPreview = document.getElementById("draft-preview");
    var attachNote = document.getElementById("draft-attach-note");
    var lineNote = document.querySelector("[data-line-note]");
    var flowItems = document.querySelectorAll(".flow-bar [data-flow]");
    var lastDraft = { subject: "", body: "", email: "", attach: "" };
    var step = 1;
    var isLine = false;
    var hintKey = "";

    function selectedSport() {
      var checked = form.querySelector('input[name="sport"]:checked');
      return checked ? checked.value : "";
    }

    function selectedWhat() {
      var checked = form.querySelector('input[name="what"]:checked');
      return checked ? checked.value : "";
    }

    function selectedShape() {
      var checked = form.querySelector('input[name="shape"]:checked');
      return checked ? checked.value : "";
    }

    function specKey(shape, what) {
      var pack = HINTS[currentLang] || HINTS.en;
      if (what && shape && pack[what + " " + shape]) return what + " " + shape;
      if (shape && pack[shape]) return shape;
      if (what && pack[what]) return what;
      return shape || what || "";
    }

    function placeFor(shape, what) {
      if (what && shape && PLACE[what + " " + shape]) return PLACE[what + " " + shape];
      if (shape && PLACE[shape]) return PLACE[shape];
      if (what && PLACE[what]) return PLACE[what];
      return "";
    }


    function show(el, on) {
      if (!el) return;
      el.hidden = !on;
    }

    function setStep(n) {
      step = n;
      form.querySelectorAll(".flow-panel").forEach(function (panel) {
        var s = Number(panel.getAttribute("data-step"));
        show(panel, s === n);
      });
      flowItems.forEach(function (li) {
        var s = Number(li.getAttribute("data-flow"));
        li.classList.toggle("is-current", s === n);
        li.classList.toggle("is-done", s < n);
      });
      form.querySelectorAll(".form-error").forEach(function (err) {
        err.classList.remove("is-on");
        err.textContent = "";
      });
      if (n === 3) fillDraft();
      var panel = form.querySelector('.flow-panel[data-step="' + n + '"]');
      if (panel) {
        var focusable = panel.querySelector("h2, input, button, textarea, [tabindex]");
        if (focusable) focusable.focus();
      }
    }

    function stepError(n, text) {
      var err = form.querySelector('[data-step-error="' + n + '"]');
      if (err) {
        err.textContent = text;
        err.classList.add("is-on");
      }
    }

    function setHint(key) {
      hintKey = key || "";
      if (!specHint) return;
      var pack = HINTS[currentLang] || HINTS.en;
      if (key && pack[key]) {
        specHint.textContent = pack[key];
        show(specHint, true);
      } else {
        specHint.textContent = "";
        show(specHint, false);
      }
    }

    function syncSport() {
      var sport = selectedSport();
      var what = selectedWhat();
      var snow = sport === "Snow";
      var water = sport === "Water";

      show(whatGate, water);
      whatInputs.forEach(function (input) {
        input.disabled = !water;
        if (!water) input.checked = false;
      });
      if (!water) what = "";

      var showShapes = snow || (water && what);
      show(shapeGate, showShapes);

      form.querySelectorAll(".pick-grid").forEach(function (grid) {
        var sportMatch = grid.getAttribute("data-sport");
        var whatMatch = grid.getAttribute("data-what");
        var match = false;
        if (sportMatch) match = sportMatch === sport;
        if (whatMatch) match = water && what === whatMatch;
        show(grid, match);
        grid.querySelectorAll('input[name="shape"]').forEach(function (input) {
          input.disabled = !match;
          if (!match) input.checked = false;
        });
      });

      if (lengthUnit) lengthUnit.textContent = snow ? msg().unit_cm : "";
      if (lengthInput && !lengthInput.value) {
        if (snow) lengthInput.placeholder = "156";
        else if (water && what) lengthInput.placeholder = placeFor(selectedShape(), what) || "6'2\"";
        else lengthInput.placeholder = "";
      }

      show(fieldLength, true);
      show(fieldWidth, snow);
      show(fieldFins, water && what === "Surfboard");
      syncShape();
    }

    function syncShape() {
      var sport = selectedSport();
      var what = selectedWhat();
      var shape = selectedShape();
      var key = specKey(shape, sport === "Water" ? what : "");
      setHint(key);
      if (lengthInput && !lengthInput.value) {
        var ph = placeFor(shape, sport === "Water" ? what : "");
        if (ph) lengthInput.placeholder = ph;
      }
    }

    function showFile(f) {
      if (!fileName) return;
      fileName.textContent = f ? f.name + (f.size ? " · " + Math.round(f.size / 1024) + " KB" : "") : "";
    }

    function waterLabel() {
      return selectedShape() || selectedWhat();
    }

    function buildDraft() {
      var m = msg();
      var name = (form.elements.name && form.elements.name.value) || "";
      var email = (form.elements.email && form.elements.email.value) || "";
      var sport = selectedSport() || "";
      var what = selectedWhat() || "";
      var shape = selectedShape() || "";
      var length = (form.elements.length && form.elements.length.value) || "";
      var width = (form.elements.width && form.elements.width.value) || "";
      var fins = (form.elements.fins && form.elements.fins.value) || "";
      var req = (form.elements.requirements && form.elements.requirements.value) || "";
      var notes = (form.elements.notes && form.elements.notes.value) || "";
      var attach = file && file.files && file.files[0] ? file.files[0].name : m.none_selected;

      var lines = [
        m.draft_name + ": " + name,
        m.draft_email + ": " + email,
        m.draft_sport + ": " + sport
      ];
      if (sport === "Water") {
        lines.push(m.draft_what + ": " + (what || "—"));
        lines.push(m.draft_shape + ": " + (shape || "—"));
      } else {
        lines.push(m.draft_shape + ": " + (shape || "—"));
      }
      if (isLine) lines.push(m.draft_qty);
      if (sport === "Snow") {
        lines.push(m.draft_length_cm + ": " + (length || "—"));
        lines.push(m.draft_width + ": " + (width || "—"));
      } else if (sport === "Water" && what === "Surfboard") {
        lines.push(m.draft_length + ": " + (length || "—"));
        lines.push(m.draft_fins + ": " + (fins || "—"));
      } else if (sport === "Water" && what) {
        lines.push(m.draft_length + ": " + (length || "—"));
      }
      lines.push(m.draft_req + ": " + (req || "—"));
      lines.push(m.draft_notes + ": " + (notes || "—"));
      lines.push(m.draft_art + ": " + attach + " " + m.draft_art_note);

      var subjectBit = [sport === "Water" ? waterLabel() : shape, name].filter(Boolean).join(" — ") || m.draft_brief;
      return {
        subject: m.draft_subject_prefix + subjectBit,
        body: lines.join("\n"),
        email: email,
        attach: attach
      };
    }

    function fillDraft() {
      var m = msg();
      var draft = buildDraft();
      lastDraft = draft;
      if (draftPreview) draftPreview.textContent = m.draft_to + ": " + MAIL + "\n" + m.draft_subject + ": " + draft.subject + "\n\n" + draft.body;
      if (attachNote) {
        attachNote.textContent = draft.attach === m.none_selected
          ? m.attach_none
          : m.attach_named.replace("{file}", draft.attach);
      }
    }

    function copyDraft() {
      var m = msg();
      var text = lastDraft.subject ? (lastDraft.subject + "\n\n" + lastDraft.body) : (buildDraft().subject + "\n\n" + buildDraft().body);
      function ok() {
        form.querySelectorAll("[data-copy], [data-copy-success]").forEach(function (btn) {
          btn.textContent = m.copied;
          window.setTimeout(function () { btn.textContent = m.copy_draft; }, 1600);
        });
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(ok).catch(function () {
          if (draftPreview) {
            var range = document.createRange();
            range.selectNodeContents(draftPreview);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
          }
        });
      } else if (draftPreview) {
        var range = document.createRange();
        range.selectNodeContents(draftPreview);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }

    function validStep(n) {
      var m = msg();
      if (n === 1) {
        var sport = selectedSport();
        if (!sport) {
          stepError(1, m.pick_sport);
          return false;
        }
        if (sport === "Water") {
          var what = selectedWhat();
          if (!what) {
            stepError(1, m.pick_water);
            return false;
          }
          if (!selectedShape()) {
            stepError(1, m.pick_shape);
            return false;
          }
          return true;
        }
        if (!selectedShape()) {
          stepError(1, m.pick_shape);
          return false;
        }
        return true;
      }
      if (n === 2) {
        var name = form.elements.name;
        var email = form.elements.email;
        if (!name.checkValidity() || !email.checkValidity()) {
          stepError(2, m.complete);
          form.reportValidity();
          return false;
        }
        return true;
      }
      return true;
    }

    function step1Incomplete() {
      var sport = selectedSport();
      if (!sport) return true;
      if (sport === "Water") {
        var what = selectedWhat();
        if (!what) return true;
        if (!selectedShape()) return true;
        return false;
      }
      return !selectedShape();
    }

    applyFormLang = function () {
      var m = msg();
      form.querySelectorAll("[data-copy], [data-copy-success]").forEach(function (btn) {
        btn.textContent = m.copy_draft;
      });
      if (lengthUnit && selectedSport() === "Snow") lengthUnit.textContent = m.unit_cm;
      if (hintKey) setHint(hintKey);
      if (step === 3) fillDraft();
      if (success && success.classList.contains("is-on") && lastDraft.email) {
        var who = success.querySelector("[data-success-email]");
        if (who) who.textContent = lastDraft.email;
      }
    };

    sportInputs.forEach(function (input) {
      input.addEventListener("change", syncSport);
    });
    whatInputs.forEach(function (input) {
      input.addEventListener("change", syncSport);
    });
    if (shapeGate) {
      shapeGate.addEventListener("change", function (e) {
        if (e.target && e.target.name === "shape") syncShape();
      });
    } else {
      shapeInputs.forEach(function (input) {
        input.addEventListener("change", syncShape);
      });
    }
    var params = new URLSearchParams(window.location.search);
    var qSport = (params.get("sport") || "").toLowerCase();
    if (qSport === "snow" || qSport === "water" || qSport === "surf") {
      var sportValue = qSport === "snow" ? "Snow" : "Water";
      var radio = form.querySelector('input[name="sport"][value="' + sportValue + '"]');
      if (radio) radio.checked = true;
      if (sportGate) sportGate.hidden = true;
    }
    var qWhat = params.get("what") || "";
    if (qWhat && (qSport === "water" || qSport === "surf" || selectedSport() === "Water")) {
      whatInputs.forEach(function (input) {
        if (input.value.toLowerCase() === qWhat.toLowerCase()) input.checked = true;
      });
    }
    if (qSport === "line") {
      isLine = true;
      if (lineNote) lineNote.hidden = false;
    }
    syncSport();
    applyFormLang();

    if (file) {
      file.addEventListener("change", function () {
        showFile(file.files && file.files[0]);
      });
    }
    if (drop && file) {
      ["dragenter", "dragover"].forEach(function (ev) {
        drop.addEventListener(ev, function (e) {
          e.preventDefault();
          drop.classList.add("is-over");
        });
      });
      ["dragleave", "drop"].forEach(function (ev) {
        drop.addEventListener(ev, function (e) {
          e.preventDefault();
          drop.classList.remove("is-over");
        });
      });
      drop.addEventListener("drop", function (e) {
        if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]) {
          try {
            file.files = e.dataTransfer.files;
          } catch (err2) {}
          showFile(e.dataTransfer.files[0]);
        }
      });
    }

    form.querySelectorAll("[data-next]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (!validStep(step)) return;
        setStep(step + 1);
      });
    });
    form.querySelectorAll("[data-back]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        setStep(Math.max(1, step - 1));
      });
    });
    form.querySelectorAll("[data-copy]").forEach(function (btn) {
      btn.addEventListener("click", copyDraft);
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!validStep(1) || !validStep(2)) {
        setStep(step1Incomplete() ? 1 : 2);
        return;
      }
      var draft = buildDraft();
      lastDraft = draft;
      var mailto =
        "mailto:" + MAIL +
        "?subject=" + encodeURIComponent(draft.subject) +
        "&body=" + encodeURIComponent(draft.body);

      if (success) {
        var who = success.querySelector("[data-success-email]");
        if (who) who.textContent = draft.email;
        form.hidden = true;
        var bar = document.querySelector(".flow-bar");
        if (bar) bar.hidden = true;
        if (lineNote) lineNote.hidden = true;
        success.classList.add("is-on");
        success.focus();
      }

      window.setTimeout(function () {
        window.location.href = mailto;
      }, 250);
    });

    var copySuccess = document.querySelector("[data-copy-success]");
    if (copySuccess) copySuccess.addEventListener("click", copyDraft);
  }


  (function waterTypeSwap() {
    var line = document.getElementById("water-types");
    var section = document.getElementById("shapes");
    if (!line || !section) return;
    var cards = line.querySelectorAll("[data-type]");
    var grids = section.querySelectorAll("[data-type-shapes]");
    var kicker = section.querySelector(".kicker");
    var heading = section.querySelector("h2");
    var lede = section.querySelector(".lede");
    var startLink = section.querySelector("[data-water-start]");
    var H2 = {
      Surfboard: "water_shapes_h2_surf",
      "Hard SUP": "water_shapes_h2_sup",
      Foil: "water_shapes_h2_foil",
      Wakeboard: "water_shapes_h2_wake",
      Wakesurf: "water_shapes_h2_wakesurf",
      Kiteboard: "water_shapes_h2_kite",
      Windsurf: "water_shapes_h2_wind",
      Skimboard: "water_shapes_h2_skim"
    };
    function startPath() {
      var cta = document.querySelector(".header-cta");
      var href = cta ? cta.getAttribute("href") : "/pages/start";
      return href.split("?")[0];
    }
    function fillI18n(el, key) {
      if (!el || !key) return;
      el.setAttribute("data-i18n", key);
      var pack = STR[currentLang] || STR.en;
      if (pack[key]) el.textContent = pack[key];
    }
    function setType(type, scroll) {
      cards.forEach(function (card) {
        var on = card.getAttribute("data-type") === type;
        card.classList.toggle("is-on", on);
        card.setAttribute("aria-pressed", String(on));
        if (on) card.setAttribute("aria-current", "true");
        else card.removeAttribute("aria-current");
      });
      grids.forEach(function (grid) {
        var match = grid.getAttribute("data-type-shapes") === type;
        grid.hidden = !match;
        if (match) {
          grid.querySelectorAll(".shape").forEach(function (el) {
            el.classList.add("is-in");
          });
        }
      });
      fillI18n(kicker, "water_shapes_kicker");
      fillI18n(heading, H2[type] || "water_shapes_h2");
      fillI18n(lede, "water_shapes_lede");
      if (startLink) {
        startLink.href = startPath() + "?sport=water&what=" + encodeURIComponent(type);
      }
      if (scroll && section) {
        var rect = section.getBoundingClientRect();
        var headerH = header ? header.offsetHeight : 0;
        var need = rect.top < headerH + 8 || rect.bottom > window.innerHeight;
        if (need) section.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }
    cards.forEach(function (card) {
      card.addEventListener("click", function () {
        setType(card.getAttribute("data-type"), true);
      });
    });
    setType("Surfboard", false);
  })();

  (function revealOnScroll() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var sel = ".card, .shape, .process-item, .matter-list li, .door, .cta-band, .faq-item";
    var nodes = document.querySelectorAll(sel);
    if (!nodes.length) return;
    nodes.forEach(function (el, i) {
      el.classList.add("reveal");
      el.style.setProperty("--d", String((i % 6) * 50) + "ms");
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-in");
        io.unobserve(entry.target);
      });
    }, { threshold: 0.14, rootMargin: "0px 0px -6% 0px" });
    nodes.forEach(function (el) { io.observe(el); });
  })();

})();
